import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
};

export type Appraisal = {
  __typename?: 'Appraisal';
  date?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum AssignmentType {
  Buy = 'Buy',
  Commercial = 'Commercial',
  DeceasedEstate = 'DeceasedEstate',
  ForcedSale = 'ForcedSale',
  Foreclosure = 'Foreclosure',
  Leisure = 'Leisure',
  NewDevelopment = 'NewDevelopment',
  NewDevelopmentCommercial = 'NewDevelopmentCommercial',
  NewDevelopmentLeisure = 'NewDevelopmentLeisure',
  OffMarket = 'OffMarket',
  Plot = 'Plot',
  ReSale = 'ReSale',
  Rent = 'Rent',
  Sale = 'Sale',
  Settlement = 'Settlement',
  Unknown = 'Unknown',
  Valuation = 'Valuation'
}

export type Attachment = {
  __typename?: 'Attachment';
  description: Scalars['String'];
  documentId: Scalars['String'];
  selected: Scalars['Boolean'];
  status: Scalars['String'];
  url: Scalars['String'];
};

export type AuthenticatedResponse = {
  __typename?: 'AuthenticatedResponse';
  name?: Maybe<Scalars['String']>;
  scopes?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Brand = {
  coreSystem: CoreSystem;
  lastChecked?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  tenant: Scalars['String'];
};

export type BrandAggregations = {
  __typename?: 'BrandAggregations';
  places?: Maybe<Array<Maybe<BrandAggregationsPlaces>>>;
};

export type BrandAggregationsPlaces = {
  __typename?: 'BrandAggregationsPlaces';
  brands?: Maybe<Array<Maybe<BrandItem>>>;
  count?: Maybe<Scalars['Int']>;
  place?: Maybe<Scalars['String']>;
};

export type BrandInput = {
  coreSystem: CoreSystem;
  lastChecked?: Maybe<Scalars['DateTime']>;
  tenant: Scalars['String'];
};

export type BrandItem = {
  __typename?: 'BrandItem';
  brands?: Maybe<Array<Maybe<Department>>>;
  name?: Maybe<Scalars['String']>;
};

export type Buildings = {
  __typename?: 'Buildings';
  areas?: Maybe<Array<BuildingsArea>>;
  name?: Maybe<Scalars['String']>;
};

export type BuildingsArea = {
  __typename?: 'BuildingsArea';
  data?: Maybe<Array<BuildingsAreaData>>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BuildingsAreaData = {
  __typename?: 'BuildingsAreaData';
  description?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Float']>;
};

export type BusinessManager = {
  __typename?: 'BusinessManager';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalPlace?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Cadaster = {
  __typename?: 'Cadaster';
  bnr: Scalars['Int'];
  fnr: Scalars['Int'];
  gnr: Scalars['Int'];
  knr: Scalars['String'];
  ownPart?: Maybe<Scalars['String']>;
  snr: Scalars['Int'];
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  checked?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Comment = {
  __typename?: 'Comment';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  owner: Scalars['Boolean'];
  parent?: Maybe<CommentParent>;
  position?: Maybe<CommentPosition>;
  replies?: Maybe<CommentReplies>;
  resolved?: Maybe<Scalars['Boolean']>;
  role: UserRole;
  sequenceNumber?: Maybe<Scalars['Int']>;
  type?: Maybe<CommentType>;
  viewport?: Maybe<CommentViewport>;
};

export type CommentParent = {
  __typename?: 'CommentParent';
  id?: Maybe<Scalars['ID']>;
};

export type CommentPosition = {
  __typename?: 'CommentPosition';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type CommentReplies = {
  __typename?: 'CommentReplies';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Comment>>>;
};

export enum CommentType {
  InPage = 'InPage',
  Reply = 'Reply',
  Sidebar = 'Sidebar'
}

export type CommentViewport = {
  __typename?: 'CommentViewport';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type Comments = {
  __typename?: 'Comments';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<Maybe<Comment>>>;
  single?: Maybe<Comment>;
};

export type CommentsListArgs = {
  filter?: Maybe<DsCommentsListFilter>;
};

export type Commercial = {
  __typename?: 'Commercial';
  companyCertificateDate?: Maybe<Scalars['DateTime']>;
  corporation?: Maybe<CommercialCorportation>;
  establishmentDate?: Maybe<Scalars['DateTime']>;
  hasGarageDoors?: Maybe<Scalars['Boolean']>;
  prices?: Maybe<CommercialPrices>;
  saleItemType?: Maybe<Scalars['String']>;
  workingPlaces?: Maybe<Scalars['Float']>;
};

export type CommercialCorportation = {
  __typename?: 'CommercialCorportation';
  name?: Maybe<Scalars['String']>;
  orgNum?: Maybe<Scalars['String']>;
};

export type CommercialPrices = {
  __typename?: 'CommercialPrices';
  bookValuePlot?: Maybe<Scalars['Float']>;
  commercialProperty?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Float']>;
  grossPropertyValue?: Maybe<Scalars['Float']>;
  marketValuePlot?: Maybe<Scalars['Float']>;
  netPropertyValue?: Maybe<Scalars['Float']>;
  numberOfShares?: Maybe<Scalars['Float']>;
  rentGuaranteeAmount?: Maybe<Scalars['Float']>;
  rentalIncome?: Maybe<Scalars['Float']>;
  rentalValue?: Maybe<Scalars['Float']>;
  revisedBalance?: Maybe<Scalars['Float']>;
  revisedSalesPrice?: Maybe<Scalars['Float']>;
  shareCapital?: Maybe<Scalars['Float']>;
  shareValue?: Maybe<Scalars['Float']>;
  taxedBalancePlot?: Maybe<Scalars['Float']>;
  taxedBalanceProperty?: Maybe<Scalars['Float']>;
  valueBehindShares?: Maybe<Scalars['Float']>;
  valueCompany?: Maybe<Scalars['Float']>;
};

export type Contact = {
  __typename?: 'Contact';
  birthDate?: Maybe<Scalars['DateTime']>;
  contactId: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgNumber?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalPlace?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  ssn?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  visitingAddress?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ContactFilterInput = {
  role?: Maybe<Array<Maybe<Role>>>;
};

export type Contacts = {
  __typename?: 'Contacts';
  buyers: Array<Maybe<Contact>>;
  list: Array<Maybe<Contact>>;
  owners: Array<Maybe<Contact>>;
  sellers: Array<Maybe<Contact>>;
  titleholders: Array<Maybe<Contact>>;
};

export type ContactsListArgs = {
  filter?: Maybe<ContactFilterInput>;
};

export type ContractDetails = {
  __typename?: 'ContractDetails';
  leasingDate?: Maybe<Scalars['DateTime']>;
  meetingDate?: Maybe<Scalars['DateTime']>;
  position?: Maybe<Scalars['String']>;
  positionGuarantees?: Maybe<Scalars['String']>;
  purchaseAttachment?: Maybe<Scalars['String']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

export enum CoreSystem {
  Unknown = 'unknown',
  Vitec = 'vitec',
  Webmegler = 'webmegler',
  Webtop = 'webtop'
}

export type CorrectionApproveInput = {
  id: Scalars['String'];
};

export type CorrectionDoneInput = {
  id: Scalars['String'];
};

export type CorrectionDoneResponse = {
  __typename?: 'CorrectionDoneResponse';
  data?: Maybe<CorrectionStatus>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CorrectionInitialInput = {
  customerId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type CorrectionInitialResponse = {
  __typename?: 'CorrectionInitialResponse';
  data?: Maybe<CorrectionStatus>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CorrectionResolvedInput = {
  id: Scalars['String'];
};

export type CorrectionResolvedResponse = {
  __typename?: 'CorrectionResolvedResponse';
  data?: Maybe<CorrectionStatus>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CorrectionStartNewInput = {
  /** Old ds id */
  id?: Maybe<Scalars['String']>;
};

export type CorrectionStartNewResponse = {
  __typename?: 'CorrectionStartNewResponse';
  id?: Maybe<Scalars['String']>;
  redirectURL?: Maybe<Scalars['String']>;
};

export type CorrectionStatus = {
  __typename?: 'CorrectionStatus';
  status?: Maybe<CorrectionStatusResponse>;
};

export type CorrectionStatusResponse = {
  __typename?: 'CorrectionStatusResponse';
  id?: Maybe<Scalars['ID']>;
  role?: Maybe<Scalars['String']>;
  type?: Maybe<CorrectionStatusType>;
};

export enum CorrectionStatusType {
  /** After customer/broker has approved */
  Approved = 'Approved',
  /** After customer is done commenting */
  Corrections = 'Corrections',
  /** After broker has posted draft */
  Draft = 'Draft',
  /** Before broker sends draft to customer */
  Initial = 'Initial',
  /** After broker is done with all updates */
  Resolved = 'Resolved'
}

export type Costs = {
  __typename?: 'Costs';
  details?: Maybe<Array<Maybe<LabelValue>>>;
  totalCosts?: Maybe<Scalars['Float']>;
  totalCostsTo?: Maybe<Scalars['Float']>;
};

export type CustomChecklist = DefaultCustomChecklist | PrivatmeglerenCustomChecklist;

export type CustomTexts = DefaultCustomTexts | PrivatmeglerenCustomTexts;

export type DsAttachmentDocument = {
  __typename?: 'DSAttachmentDocument';
  documentId: Scalars['String'];
  url: Scalars['String'];
};

export type DsAttachmentDocumentInput = {
  documentId: Scalars['String'];
};

export type DsAttachmentReorder = {
  __typename?: 'DSAttachmentReorder';
  attachments?: Maybe<Array<Maybe<DsAttachmentDocument>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DsAttachmentReorderInput = {
  attachments?: Maybe<Array<Maybe<DsAttachmentDocumentInput>>>;
  id: Scalars['String'];
};

export type DsAttachmentSelect = {
  __typename?: 'DSAttachmentSelect';
  success?: Maybe<Scalars['Boolean']>;
  updatedAttachments?: Maybe<Array<Maybe<DsAttachmentDocument>>>;
};

export type DsAttachmentSelectAll = {
  __typename?: 'DSAttachmentSelectAll';
  attachments?: Maybe<Array<Maybe<DsAttachmentDocument>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DsAttachmentSelectAllInput = {
  attachments: Array<Maybe<DsAttachmentDocumentInput>>;
  id: Scalars['String'];
};

export type DsAttachmentSelectInput = {
  documentId: Scalars['String'];
  id: Scalars['String'];
};

export type DsVersionExistInput = {
  estateId: Scalars['String'];
};

export type Debt = {
  __typename?: 'Debt';
  collectiveDebt?: Maybe<Scalars['Float']>;
  collectiveDebtTo?: Maybe<Scalars['Float']>;
  validatedDate?: Maybe<Scalars['DateTime']>;
};

export type DefaultCustomChecklist = {
  __typename?: 'DefaultCustomChecklist';
  list?: Maybe<Array<ChecklistItem>>;
};

export type DefaultCustomTexts = {
  __typename?: 'DefaultCustomTexts';
  customText?: Maybe<TextItem>;
};

export type DefaultEstateFlags = {
  __typename?: 'DefaultEstateFlags';
  isDoubleHomeInsurance?: Maybe<Scalars['Boolean']>;
  isDownsized?: Maybe<Scalars['Boolean']>;
  isEvent?: Maybe<Scalars['Boolean']>;
  isNotis?: Maybe<Scalars['Boolean']>;
  isTeaser?: Maybe<Scalars['Boolean']>;
};

export type Department = {
  __typename?: 'Department';
  alias: Scalars['ID'];
  brandId: Scalars['ID'];
  /** Name of partner brand (example: "Schala") */
  coordinates?: Maybe<Coordinates>;
  cover?: Maybe<DepartmentCover>;
  departmentId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  employees?: Maybe<Array<Maybe<Employee>>>;
  fax?: Maybe<Scalars['String']>;
  features?: Maybe<DepartmentFeatures>;
  legalName?: Maybe<Scalars['String']>;
  localArea?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  municipalityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgNumber?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  postalPlace?: Maybe<Scalars['String']>;
  postalZip?: Maybe<Scalars['String']>;
  pricelist?: Maybe<Array<Maybe<PricelistItem>>>;
  referenceUrls?: Maybe<DepartmentReferenceUrls>;
  /** Only available on estates */
  role?: Maybe<Role>;
  shortName?: Maybe<Scalars['String']>;
  stats?: Maybe<DepartmentStats>;
  tags?: Maybe<Array<Scalars['String']>>;
  texts?: Maybe<DepartmentTexts>;
  type?: Maybe<Scalars['String']>;
  visitingAddress?: Maybe<Scalars['String']>;
};

export type DepartmentCover = {
  __typename?: 'DepartmentCover';
  fallback?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type DepartmentFeature = {
  __typename?: 'DepartmentFeature';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type DepartmentFeatures = {
  __typename?: 'DepartmentFeatures';
  soldprice?: Maybe<DepartmentFeature>;
};

export type DepartmentInput = {
  alias?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DepartmentReferenceUrls = {
  __typename?: 'DepartmentReferenceUrls';
  departmentContactUrl?: Maybe<Scalars['String']>;
  departmentUrl?: Maybe<Scalars['String']>;
  departmentValuationUrl?: Maybe<Scalars['String']>;
  memberUrl?: Maybe<Scalars['String']>;
  pricelistUrl?: Maybe<Scalars['String']>;
  valuationUrl?: Maybe<Scalars['String']>;
};

export type DepartmentStats = {
  __typename?: 'DepartmentStats';
  averageDaysOnMarketBeforeSold?: Maybe<StatItem>;
  brokers?: Maybe<StatItem>;
  employees?: Maybe<StatItem>;
  soldInTwelveMonths?: Maybe<StatItem>;
  soldLastMonth?: Maybe<StatItem>;
};

export enum DepartmentTag {
  Commercial = 'Commercial',
  Leisure = 'Leisure',
  NewDevelopment = 'NewDevelopment',
  NewDevelopmentCommercial = 'NewDevelopmentCommercial',
  NewDevelopmentLeisure = 'NewDevelopmentLeisure'
}

export type DepartmentTexts = DepartmentTextsDefault;

export type DepartmentTextsDefault = {
  __typename?: 'DepartmentTextsDefault';
  about?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  pricelist?: Maybe<Scalars['String']>;
  purchaseBrokerage?: Maybe<Scalars['String']>;
  valuation?: Maybe<Scalars['String']>;
};

export type Departments = {
  __typename?: 'Departments';
  list: Array<Maybe<Department>>;
  main?: Maybe<Department>;
  settlement?: Maybe<Department>;
};

export type Document = {
  __typename?: 'Document';
  category: Scalars['String'];
  description: Scalars['String'];
  documentId: Scalars['String'];
  extension?: Maybe<Scalars['String']>;
  isAttachment: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  url: Scalars['String'];
};

export type DocumentInput = {
  coreSystem: CoreSystem;
  documentId?: Maybe<Scalars['String']>;
  estateId: Scalars['String'];
  tenant: Scalars['String'];
};

export type Documents = {
  __typename?: 'Documents';
  attachments: Array<Maybe<Document>>;
  list: Array<Maybe<Document>>;
  private: Array<Maybe<Document>>;
  public: Array<Maybe<Document>>;
};

export type DsApproveInput = {
  id: Scalars['String'];
};

export type DsApproveResponse = {
  __typename?: 'DsApproveResponse';
  _id: Scalars['String'];
  data?: Maybe<CorrectionStatus>;
  success?: Maybe<Scalars['Boolean']>;
  url?: Maybe<DsUrl>;
  uuid?: Maybe<Scalars['String']>;
};

export type DsAttachment = {
  __typename?: 'DsAttachment';
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum DsAttachmentSettingsType {
  DsId = 'DsID',
  VersionUuid = 'VersionUUID'
}

export enum DsAttachmentStatus {
  Error = 'Error',
  Pending = 'Pending',
  Ready = 'Ready'
}

export enum DsAttachmentType {
  None = 'none',
  Preselected = 'preselected',
  Selection = 'selection'
}

export type DsCommentAddInput = {
  comment: Scalars['String'];
  position?: Maybe<DsCommentPositionInput>;
  referenceId: Scalars['String'];
  replyToId?: Maybe<Scalars['String']>;
  type: CommentType;
  viewport?: Maybe<DsCommentViewportInput>;
};

export type DsCommentAddResponse = {
  __typename?: 'DsCommentAddResponse';
  _id: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type DsCommentInput = {
  id?: Maybe<Scalars['String']>;
};

export type DsCommentPositionInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type DsCommentPositionUpdateInput = {
  id: Scalars['String'];
  position?: Maybe<DsCommentPositionInput>;
};

export type DsCommentPositionUpdateResponse = {
  __typename?: 'DsCommentPositionUpdateResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DsCommentRemoveInput = {
  id: Scalars['String'];
};

export type DsCommentRemoveResponse = {
  __typename?: 'DsCommentRemoveResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DsCommentResolveInput = {
  estateId: Scalars['String'];
  id: Scalars['String'];
  resolved?: Maybe<Scalars['Boolean']>;
};

export type DsCommentResolveResponse = {
  __typename?: 'DsCommentResolveResponse';
  resolved?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DsCommentUpdateInput = {
  comment?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type DsCommentUpdateResponse = {
  __typename?: 'DsCommentUpdateResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DsCommentViewportInput = {
  deviceScaleFactor: Scalars['Int'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type DsCommentsInput = {
  id?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type DsCommentsListFilter = {
  type?: Maybe<DsCommentsType>;
};

export enum DsCommentsType {
  All = 'All',
  New = 'New'
}

export type DsExistInput = {
  estateId: Scalars['String'];
  id: Scalars['String'];
};

export type DsExistResponse = {
  __typename?: 'DsExistResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DsHasRequiredAttachments = {
  __typename?: 'DsHasRequiredAttachments';
  attachments?: Maybe<Scalars['Boolean']>;
  hint?: Maybe<Scalars['String']>;
};

export type DsLatestVersion = {
  __typename?: 'DsLatestVersion';
  url?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type DsLatestVersionUrlArgs = {
  format?: Maybe<DsUrlFormat>;
};

export type DsLatestVersionInput = {
  estateId: Scalars['String'];
};

export type DsMainSeller = {
  __typename?: 'DsMainSeller';
  name?: Maybe<Scalars['String']>;
};

export type DsPendingCustomerInput = {
  id: Scalars['String'];
};

export type DsPendingCustomerResponse = {
  __typename?: 'DsPendingCustomerResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DsReadyAttachment = {
  __typename?: 'DsReadyAttachment';
  status?: Maybe<DsAttachmentStatus>;
  url?: Maybe<Scalars['String']>;
};

export type DsSettings = {
  __typename?: 'DsSettings';
  /** Ready attachment to be used in public view */
  attachment?: Maybe<DsReadyAttachment>;
  attachmentType?: Maybe<DsAttachmentType>;
  /** Return list of all selected attachments */
  attachments?: Maybe<Array<Maybe<DsAttachment>>>;
  currentStatus?: Maybe<DsStatus>;
  exist?: Maybe<Scalars['Boolean']>;
  features?: Maybe<DsSettingsFeatures>;
  /** Check if there are previous versions */
  hasPreviousVersions?: Maybe<Scalars['Boolean']>;
  /** Check for attachment when attachment type is preselected */
  hasRequiredAttachment?: Maybe<DsHasRequiredAttachments>;
  hasSelectedAttachment?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  /** Check if current user is main seller, only selected seller will be true */
  isMainSeller?: Maybe<Scalars['Boolean']>;
  latest?: Maybe<DsLatestVersion>;
  /** Info about main seller (only for correction) */
  mainSeller?: Maybe<DsMainSeller>;
  refreshOnPageLoad?: Maybe<Scalars['Boolean']>;
  status?: Maybe<DsSettingsStatus>;
};

export type DsSettingsFeature = {
  __typename?: 'DsSettingsFeature';
  enabled?: Maybe<Scalars['Boolean']>;
  theme?: Maybe<Scalars['JSON']>;
};

export type DsSettingsFeatures = {
  __typename?: 'DsSettingsFeatures';
  correction?: Maybe<DsSettingsFeature>;
};

export type DsSettingsInput = {
  estateId?: Maybe<Scalars['String']>;
  /** ds order id */
  id?: Maybe<Scalars['String']>;
  /** version (uuid) for ds */
  version?: Maybe<Scalars['String']>;
};

export type DsSettingsStatus = {
  __typename?: 'DsSettingsStatus';
  approved?: Maybe<Scalars['Boolean']>;
  corrections?: Maybe<Scalars['Boolean']>;
  draft?: Maybe<Scalars['Boolean']>;
  initial?: Maybe<Scalars['Boolean']>;
  resolved?: Maybe<Scalars['Boolean']>;
};

export enum DsStatus {
  /** After customer/broker has approved */
  Approved = 'Approved',
  /** After customer is done commenting (only for correction) */
  Corrections = 'Corrections',
  /** After broker has posted draft (only for correction) */
  Draft = 'Draft',
  /** Before broker sends draft to customer */
  Initial = 'Initial',
  /** After broker is done with all updates (only for correction) */
  Resolved = 'Resolved'
}

export type DsTextItem = {
  __typename?: 'DsTextItem';
  heading?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type DsTextsInput = {
  assignmentType?: Maybe<AssignmentType>;
  textType?: Maybe<Scalars['String']>;
  /** UUID of the snapshot/version that is approved. */
  uuid?: Maybe<Scalars['String']>;
};

export type DsUrl = {
  __typename?: 'DsUrl';
  absolute?: Maybe<Scalars['String']>;
  relative?: Maybe<Scalars['String']>;
};

export type DsUrlFormat = {
  absolute?: Maybe<Scalars['Boolean']>;
};

export type Easement = {
  __typename?: 'Easement';
  heading?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type Eiendomsprofil = {
  __typename?: 'Eiendomsprofil';
  disclaimer?: Maybe<Scalars['String']>;
  meta?: Maybe<EiendomsprofilMeta>;
  profile?: Maybe<EiendomsprofilProfile>;
  version?: Maybe<Scalars['String']>;
};

export type EiendomsprofilBoligmasse = {
  __typename?: 'EiendomsprofilBoligmasse';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EiendomsprofilCoordinates = {
  __typename?: 'EiendomsprofilCoordinates';
  lat?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['String']>;
  utmx?: Maybe<Scalars['String']>;
  utmy?: Maybe<Scalars['String']>;
};

export type EiendomsprofilCounty = {
  __typename?: 'EiendomsprofilCounty';
  name?: Maybe<Scalars['String']>;
  nr?: Maybe<Scalars['String']>;
};

export type EiendomsprofilDemografics = {
  __typename?: 'EiendomsprofilDemografics';
  boligmasse?: Maybe<Array<Maybe<EiendomsprofilBoligmasse>>>;
  percent_text?: Maybe<Array<Maybe<EiendomsprofilPercentText>>>;
};

export type EiendomsprofilDemographicsSplit = {
  __typename?: 'EiendomsprofilDemographicsSplit';
  ALD6_12?: Maybe<EiendomsprofilValuePercent>;
  ALD13_15?: Maybe<EiendomsprofilValuePercent>;
  ALD16_18?: Maybe<EiendomsprofilValuePercent>;
  ALD19_23?: Maybe<EiendomsprofilValuePercent>;
  ALD24_34?: Maybe<EiendomsprofilValuePercent>;
  ALD35_44?: Maybe<EiendomsprofilValuePercent>;
  ALD45_54?: Maybe<EiendomsprofilValuePercent>;
  ALD55_64?: Maybe<EiendomsprofilValuePercent>;
  ALD65_74?: Maybe<EiendomsprofilValuePercent>;
  ALD75_84?: Maybe<EiendomsprofilValuePercent>;
  ALD85_O?: Maybe<EiendomsprofilValuePercent>;
  ALDU_5?: Maybe<EiendomsprofilValuePercent>;
  ENKE_ENKEM?: Maybe<EiendomsprofilValuePercent>;
  ENSLIG?: Maybe<EiendomsprofilValuePercent>;
  ENSLIG_M_B?: Maybe<EiendomsprofilValuePercent>;
  ENSLIG_U_B?: Maybe<EiendomsprofilValuePercent>;
  FLERFAMILI?: Maybe<EiendomsprofilValuePercent>;
  GIFT?: Maybe<EiendomsprofilValuePercent>;
  PAR?: Maybe<EiendomsprofilValuePercent>;
  PAR_M_BARN?: Maybe<EiendomsprofilValuePercent>;
  PAR_U_BARN?: Maybe<EiendomsprofilValuePercent>;
  SEPARERT_S?: Maybe<EiendomsprofilValuePercent>;
  TOTAL_HUS?: Maybe<EiendomsprofilValuePercent>;
  TOT_ANTA?: Maybe<EiendomsprofilValuePercent>;
  UGIFT_KVIN?: Maybe<EiendomsprofilValuePercent>;
  UGIFT_MANN?: Maybe<EiendomsprofilValuePercent>;
};

export type EiendomsprofilDistances = {
  __typename?: 'EiendomsprofilDistances';
  air?: Maybe<Scalars['Float']>;
  drive?: Maybe<Scalars['Float']>;
  selected?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  walk?: Maybe<Scalars['Float']>;
};

export type EiendomsprofilDuration = {
  __typename?: 'EiendomsprofilDuration';
  drive?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  walk?: Maybe<Scalars['Float']>;
};

export type EiendomsprofilEducationSplit = {
  __typename?: 'EiendomsprofilEducationSplit';
  ALLMENNE_F?: Maybe<EiendomsprofilValuePercent>;
  GRUNNSKOLE?: Maybe<EiendomsprofilValuePercent>;
  H1_AAR?: Maybe<EiendomsprofilValuePercent>;
  HELSE_SOSI?: Maybe<EiendomsprofilValuePercent>;
  HOGSKOLE_1?: Maybe<EiendomsprofilValuePercent>;
  HOGSKOLE_U?: Maybe<EiendomsprofilValuePercent>;
  HUMAN_ESTE?: Maybe<EiendomsprofilValuePercent>;
  INGEN_UOPP?: Maybe<EiendomsprofilValuePercent>;
  LARERUTDAN?: Maybe<EiendomsprofilValuePercent>;
  NATVIT_HAN?: Maybe<EiendomsprofilValuePercent>;
  OKONOMISKE?: Maybe<EiendomsprofilValuePercent>;
  PRIMARNARI?: Maybe<EiendomsprofilValuePercent>;
  SAMFERDS_S?: Maybe<EiendomsprofilValuePercent>;
  SAMFUNNSFA?: Maybe<EiendomsprofilValuePercent>;
  TOT_U_FELT?: Maybe<EiendomsprofilValuePercent>;
  UOPPGITT?: Maybe<EiendomsprofilValuePercent>;
  VIDEREGAEN?: Maybe<EiendomsprofilValuePercent>;
};

export type EiendomsprofilGrunnkretsDemografics = {
  __typename?: 'EiendomsprofilGrunnkretsDemografics';
  demografics?: Maybe<EiendomsprofilGrunnkretsDemograficsDemografics>;
  education?: Maybe<EiendomsprofilGrunnkretsDemograficsEducation>;
  housing?: Maybe<EiendomsprofilGrunnkretsDemograficsHousing>;
  income?: Maybe<EiendomsprofilGrunnkretsDemograficsIncome>;
};

export type EiendomsprofilGrunnkretsDemograficsDemografics = {
  __typename?: 'EiendomsprofilGrunnkretsDemograficsDemografics';
  grunnkrets?: Maybe<EiendomsprofilDemographicsSplit>;
  kommune?: Maybe<EiendomsprofilDemographicsSplit>;
  norge?: Maybe<EiendomsprofilDemographicsSplit>;
};

export type EiendomsprofilGrunnkretsDemograficsEducation = {
  __typename?: 'EiendomsprofilGrunnkretsDemograficsEducation';
  grunnkrets?: Maybe<EiendomsprofilEducationSplit>;
  kommune?: Maybe<EiendomsprofilEducationSplit>;
  norge?: Maybe<EiendomsprofilEducationSplit>;
};

export type EiendomsprofilGrunnkretsDemograficsHousing = {
  __typename?: 'EiendomsprofilGrunnkretsDemograficsHousing';
  grunnkrets?: Maybe<EiendomsprofilHousingSplit>;
  kommune?: Maybe<EiendomsprofilHousingSplit>;
  norge?: Maybe<EiendomsprofilHousingSplit>;
};

export type EiendomsprofilGrunnkretsDemograficsIncome = {
  __typename?: 'EiendomsprofilGrunnkretsDemograficsIncome';
  grunnkrets?: Maybe<EiendomsprofilIncomeSplit>;
  kommune?: Maybe<EiendomsprofilIncomeSplit>;
  norge?: Maybe<EiendomsprofilIncomeSplit>;
};

export type EiendomsprofilHousingSplit = {
  __typename?: 'EiendomsprofilHousingSplit';
  AR50_59?: Maybe<EiendomsprofilValuePercent>;
  AR60_79?: Maybe<EiendomsprofilValuePercent>;
  AR80_99?: Maybe<EiendomsprofilValuePercent>;
  AR100_119?: Maybe<EiendomsprofilValuePercent>;
  AR120_139?: Maybe<EiendomsprofilValuePercent>;
  AR140_159?: Maybe<EiendomsprofilValuePercent>;
  AR160_199?: Maybe<EiendomsprofilValuePercent>;
  AR200_249?: Maybe<EiendomsprofilValuePercent>;
  AR250_O?: Maybe<EiendomsprofilValuePercent>;
  ARU_50?: Maybe<EiendomsprofilValuePercent>;
  E500_1000?: Maybe<EiendomsprofilValuePercent>;
  E1000_1500?: Maybe<EiendomsprofilValuePercent>;
  E1500_2000?: Maybe<EiendomsprofilValuePercent>;
  E2000_2500?: Maybe<EiendomsprofilValuePercent>;
  E2500_3000?: Maybe<EiendomsprofilValuePercent>;
  E3000_4000?: Maybe<EiendomsprofilValuePercent>;
  E4000_5000?: Maybe<EiendomsprofilValuePercent>;
  E5000_6000?: Maybe<EiendomsprofilValuePercent>;
  E6000_O?: Maybe<EiendomsprofilValuePercent>;
  EIER_I_BOR?: Maybe<EiendomsprofilValuePercent>;
  EU_500?: Maybe<EiendomsprofilValuePercent>;
  H1_AAR?: Maybe<EiendomsprofilValuePercent>;
  H2_5_AAR?: Maybe<EiendomsprofilValuePercent>;
  H2_AAR?: Maybe<EiendomsprofilValuePercent>;
  H5_10_AAR?: Maybe<EiendomsprofilValuePercent>;
  H10_20_AAR?: Maybe<EiendomsprofilValuePercent>;
  H20_30_AAR?: Maybe<EiendomsprofilValuePercent>;
  H30_40_AAR?: Maybe<EiendomsprofilValuePercent>;
  H40_50_AAR?: Maybe<EiendomsprofilValuePercent>;
  HOVER_50_AAR?: Maybe<EiendomsprofilValuePercent>;
  H_UKJENT?: Maybe<EiendomsprofilValuePercent>;
  LEIER?: Maybe<EiendomsprofilValuePercent>;
  SELVEIER?: Maybe<EiendomsprofilValuePercent>;
  SNITT_AREA?: Maybe<EiendomsprofilValuePercent>;
  SNITT_BOLI?: Maybe<EiendomsprofilValuePercent>;
  TOT_BOLALD?: Maybe<EiendomsprofilValuePercent>;
  TOT_BOLARE?: Maybe<EiendomsprofilValuePercent>;
  TOT_HYTEIE?: Maybe<EiendomsprofilValuePercent>;
  UKJENT?: Maybe<EiendomsprofilValuePercent>;
};

export type EiendomsprofilIncomeSplit = {
  __typename?: 'EiendomsprofilIncomeSplit';
  INT0?: Maybe<EiendomsprofilValuePercent>;
  INT0_100?: Maybe<EiendomsprofilValuePercent>;
  INT100_200?: Maybe<EiendomsprofilValuePercent>;
  INT200_300?: Maybe<EiendomsprofilValuePercent>;
  INT300_400?: Maybe<EiendomsprofilValuePercent>;
  INT400_500?: Maybe<EiendomsprofilValuePercent>;
  INT500_600?: Maybe<EiendomsprofilValuePercent>;
  INT600_700?: Maybe<EiendomsprofilValuePercent>;
  INT700_800?: Maybe<EiendomsprofilValuePercent>;
  INT800_1000?: Maybe<EiendomsprofilValuePercent>;
  INT1000_1500?: Maybe<EiendomsprofilValuePercent>;
  INT1500_?: Maybe<EiendomsprofilValuePercent>;
  SNITT_INT?: Maybe<EiendomsprofilValuePercent>;
  TOT_INNTEK?: Maybe<EiendomsprofilValuePercent>;
};

export type EiendomsprofilInfo = {
  __typename?: 'EiendomsprofilInfo';
  adresse?: Maybe<Scalars['String']>;
  bydel?: Maybe<Scalars['String']>;
  county?: Maybe<EiendomsprofilCounty>;
  finnkode?: Maybe<Scalars['Float']>;
  grunnkrets?: Maybe<Scalars['String']>;
  kommune?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  long?: Maybe<Scalars['String']>;
  matrikkel?: Maybe<Scalars['String']>;
  orderLineId?: Maybe<Scalars['Float']>;
  postnr?: Maybe<Scalars['String']>;
  poststed?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['String']>;
  y?: Maybe<Scalars['String']>;
};

export type EiendomsprofilInput = {
  __typename?: 'EiendomsprofilInput';
  apiKey?: Maybe<Scalars['String']>;
  baseUrl?: Maybe<Scalars['String']>;
  estateId?: Maybe<Scalars['String']>;
};

export type EiendomsprofilLine = {
  __typename?: 'EiendomsprofilLine';
  lineId?: Maybe<Scalars['String']>;
};

export type EiendomsprofilLink = {
  __typename?: 'EiendomsprofilLink';
  href?: Maybe<Scalars['String']>;
  rel?: Maybe<Scalars['String']>;
};

export type EiendomsprofilMeta = {
  __typename?: 'EiendomsprofilMeta';
  links?: Maybe<Array<Maybe<EiendomsprofilLink>>>;
  order?: Maybe<EiendomsprofilOrder>;
  ready?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type EiendomsprofilNabolag = {
  __typename?: 'EiendomsprofilNabolag';
  cityName?: Maybe<Scalars['String']>;
  completedratings?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primaryTransport?: Maybe<Array<Maybe<EiendomsprofilNameScore>>>;
  quotes?: Maybe<Array<Maybe<EiendomsprofilQuote>>>;
  ratings?: Maybe<Array<Maybe<EiendomsprofilRating>>>;
  recommendedfor?: Maybe<Array<Maybe<EiendomsprofilNameScore>>>;
};

export type EiendomsprofilNabolagDemografics = {
  __typename?: 'EiendomsprofilNabolagDemografics';
  demografics?: Maybe<EiendomsprofilNabolagDemograficsDemografics>;
  education?: Maybe<EiendomsprofilNabolagDemograficsEducation>;
  housing?: Maybe<EiendomsprofilNabolagDemograficsHousing>;
  income?: Maybe<EiendomsprofilNabolagDemograficsIncome>;
};

export type EiendomsprofilNabolagDemograficsDemografics = {
  __typename?: 'EiendomsprofilNabolagDemograficsDemografics';
  by?: Maybe<EiendomsprofilDemographicsSplit>;
  nabolag?: Maybe<EiendomsprofilDemographicsSplit>;
  norge?: Maybe<EiendomsprofilDemographicsSplit>;
};

export type EiendomsprofilNabolagDemograficsEducation = {
  __typename?: 'EiendomsprofilNabolagDemograficsEducation';
  by?: Maybe<EiendomsprofilEducationSplit>;
  nabolag?: Maybe<EiendomsprofilEducationSplit>;
  norge?: Maybe<EiendomsprofilEducationSplit>;
};

export type EiendomsprofilNabolagDemograficsHousing = {
  __typename?: 'EiendomsprofilNabolagDemograficsHousing';
  by?: Maybe<EiendomsprofilHousingSplit>;
  nabolag?: Maybe<EiendomsprofilHousingSplit>;
  norge?: Maybe<EiendomsprofilHousingSplit>;
};

export type EiendomsprofilNabolagDemograficsIncome = {
  __typename?: 'EiendomsprofilNabolagDemograficsIncome';
  by?: Maybe<EiendomsprofilIncomeSplit>;
  nabolag?: Maybe<EiendomsprofilIncomeSplit>;
  norge?: Maybe<EiendomsprofilIncomeSplit>;
};

export type EiendomsprofilNameScore = {
  __typename?: 'EiendomsprofilNameScore';
  name?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
};

export type EiendomsprofilNearby = {
  __typename?: 'EiendomsprofilNearby';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  poiTypeId?: Maybe<Scalars['String']>;
};

export type EiendomsprofilNorId = {
  __typename?: 'EiendomsprofilNorId';
  address?: Maybe<Scalars['String']>;
  bnr?: Maybe<Scalars['Int']>;
  fnr?: Maybe<Scalars['Int']>;
  gnr?: Maybe<Scalars['Int']>;
  kommuneNr?: Maybe<Scalars['Int']>;
  snr?: Maybe<Scalars['Int']>;
};

export type EiendomsprofilOrder = {
  __typename?: 'EiendomsprofilOrder';
  changed?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  norId?: Maybe<EiendomsprofilNorId>;
  references?: Maybe<EiendomsprofilReferences>;
  source?: Maybe<EiendomsprofilSource>;
  status?: Maybe<Scalars['String']>;
};

export type EiendomsprofilPercentText = {
  __typename?: 'EiendomsprofilPercentText';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EiendomsprofilPoi = {
  __typename?: 'EiendomsprofilPoi';
  amount?: Maybe<Scalars['String']>;
  coordinates?: Maybe<EiendomsprofilCoordinates>;
  distances?: Maybe<EiendomsprofilDistances>;
  duration?: Maybe<EiendomsprofilDuration>;
  facilityTypes?: Maybe<Scalars['String']>;
  kommuner?: Maybe<Scalars['String']>;
  lines?: Maybe<Array<Maybe<EiendomsprofilLine>>>;
  name?: Maybe<Scalars['String']>;
  nearby?: Maybe<Array<Maybe<EiendomsprofilNearby>>>;
  poiId?: Maybe<Scalars['String']>;
  pointName?: Maybe<Scalars['String']>;
  poitypeId?: Maybe<Scalars['Float']>;
  population?: Maybe<Scalars['Float']>;
  school?: Maybe<EiendomsprofilSchool>;
  transportTypes?: Maybe<Array<Maybe<Scalars['Float']>>>;
  uteliv?: Maybe<Scalars['Float']>;
  villageType?: Maybe<Scalars['String']>;
};

export type EiendomsprofilPoiGroup = {
  __typename?: 'EiendomsprofilPoiGroup';
  name?: Maybe<Scalars['String']>;
  pois?: Maybe<Array<Maybe<EiendomsprofilPoi>>>;
};

export type EiendomsprofilProfile = {
  __typename?: 'EiendomsprofilProfile';
  demographics?: Maybe<EiendomsprofilDemografics>;
  grunnkrets_demografics?: Maybe<EiendomsprofilGrunnkretsDemografics>;
  info?: Maybe<EiendomsprofilInfo>;
  nabolag?: Maybe<EiendomsprofilNabolag>;
  nabolag_demografics?: Maybe<EiendomsprofilNabolagDemografics>;
  poiGroups?: Maybe<Array<Maybe<EiendomsprofilPoiGroup>>>;
};

export type EiendomsprofilQuote = {
  __typename?: 'EiendomsprofilQuote';
  credit?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type EiendomsprofilRating = {
  __typename?: 'EiendomsprofilRating';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  question?: Maybe<EiendomsprofilRatingQuestion>;
  score?: Maybe<EiendomsprofilRatingScore>;
};

export type EiendomsprofilRatingQuestion = {
  __typename?: 'EiendomsprofilRatingQuestion';
  options?: Maybe<Array<Maybe<EiendomsprofilRatingQuestionOptions>>>;
  text?: Maybe<Scalars['String']>;
};

export type EiendomsprofilRatingQuestionOptions = {
  __typename?: 'EiendomsprofilRatingQuestionOptions';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
};

export type EiendomsprofilRatingScore = {
  __typename?: 'EiendomsprofilRatingScore';
  averageCity?: Maybe<Scalars['String']>;
  averageScore?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type EiendomsprofilReferences = {
  __typename?: 'EiendomsprofilReferences';
  external?: Maybe<Scalars['String']>;
  externalAlt?: Maybe<Scalars['String']>;
  finnNoCode?: Maybe<Scalars['String']>;
};

export type EiendomsprofilSchool = {
  __typename?: 'EiendomsprofilSchool';
  classes?: Maybe<Scalars['Float']>;
  students?: Maybe<Scalars['Float']>;
};

export type EiendomsprofilSource = {
  __typename?: 'EiendomsprofilSource';
  distributor?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  portbackUrl?: Maybe<Scalars['String']>;
};

export type EiendomsprofilValuePercent = {
  __typename?: 'EiendomsprofilValuePercent';
  percent?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type Employee = {
  __typename?: 'Employee';
  about?: Maybe<Scalars['String']>;
  brandId: Scalars['ID'];
  departments: Array<Maybe<Department>>;
  email?: Maybe<Scalars['String']>;
  employeeAlias?: Maybe<Scalars['ID']>;
  employeeId: Scalars['ID'];
  estates?: Maybe<SearchResultEstate>;
  image?: Maybe<EmployeeImage>;
  isPublic?: Maybe<Scalars['Boolean']>;
  links?: Maybe<EmployeeLinks>;
  meglercv?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Only available on estates */
  role?: Maybe<Role>;
  stats?: Maybe<EmployeeStats>;
  texts?: Maybe<EmployeeTexts>;
  title?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
};

export type EmployeeEstatesArgs = {
  filter?: Maybe<SearchFilterEstate>;
  input: SearchInput;
};

export type EmployeeImage = {
  __typename?: 'EmployeeImage';
  fallback?: Maybe<Scalars['String']>;
  /** @deprecated Use `url` instead with arguments */
  large?: Maybe<Scalars['String']>;
  /** @deprecated Use `url` instead with arguments */
  medium?: Maybe<Scalars['String']>;
  /** @deprecated Use `url` instead with arguments */
  original?: Maybe<Scalars['String']>;
  /** @deprecated Use `url` instead with arguments */
  thumb?: Maybe<Scalars['String']>;
  /** size argument is only available for Vitec and Core */
  url?: Maybe<Scalars['String']>;
};

export type EmployeeImageUrlArgs = {
  size?: Maybe<EmployeeImageSize>;
};

export enum EmployeeImageSize {
  Large = 'Large',
  Medium = 'Medium',
  Original = 'Original',
  Thumb = 'Thumb'
}

export type EmployeeInput = {
  brandId?: Maybe<Scalars['String']>;
  coreId?: Maybe<Scalars['String']>;
  employeeAlias?: Maybe<Scalars['String']>;
};

export type EmployeeLink = {
  __typename?: 'EmployeeLink';
  path?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type EmployeeLinks = {
  __typename?: 'EmployeeLinks';
  contact?: Maybe<EmployeeLink>;
  profile?: Maybe<EmployeeLink>;
  valuation?: Maybe<EmployeeLink>;
  vcard?: Maybe<EmployeeLink>;
};

export type EmployeeStats = {
  __typename?: 'EmployeeStats';
  soldInTwelveMonths?: Maybe<StatItem>;
  soldLastMonth?: Maybe<StatItem>;
};

export type EmployeeTexts = EmployeeTextsDefault;

export type EmployeeTextsDefault = {
  __typename?: 'EmployeeTextsDefault';
  about?: Maybe<Scalars['String']>;
};

export type Employees = {
  __typename?: 'Employees';
  assistant?: Maybe<Employee>;
  associate?: Maybe<Employee>;
  list: Array<Maybe<Employee>>;
  main?: Maybe<Employee>;
  responsible?: Maybe<Employee>;
  settlement?: Maybe<Employee>;
};

export type EmployeesListArgs = {
  excludeDuplicates?: Maybe<Scalars['Boolean']>;
  includePublicOnly?: Maybe<Scalars['Boolean']>;
};

export type Energy = {
  __typename?: 'Energy';
  color?: Maybe<EnergyColor>;
  letter?: Maybe<EnergyLetter>;
};

export enum EnergyColor {
  Green = 'green',
  LightGreen = 'lightGreen',
  Orange = 'orange',
  Red = 'red',
  Unknown = 'unknown',
  Yellow = 'yellow'
}

export enum EnergyLetter {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  Unknown = 'unknown'
}

export type Estate = {
  __typename?: 'Estate';
  apartmentNumber?: Maybe<Scalars['String']>;
  appraisal?: Maybe<Appraisal>;
  /** Oppdrag inngått dato */
  assignmentDate?: Maybe<Scalars['DateTime']>;
  assignmentNumber?: Maybe<Scalars['String']>;
  assignmentType?: Maybe<Scalars['String']>;
  assignmentTypeMapped?: Maybe<AssignmentType>;
  attachments?: Maybe<Array<Attachment>>;
  bidReceived?: Maybe<Scalars['Float']>;
  brandId?: Maybe<Scalars['ID']>;
  buildings?: Maybe<Array<Maybe<Buildings>>>;
  businessManager?: Maybe<BusinessManager>;
  cadaster?: Maybe<Cadaster>;
  cadasters?: Maybe<Array<Maybe<Cadaster>>>;
  changedDate?: Maybe<Scalars['DateTime']>;
  checklist?: Maybe<Array<Maybe<ChecklistItem>>>;
  checklistCustom?: Maybe<CustomChecklist>;
  commercial?: Maybe<Commercial>;
  constructionYear?: Maybe<Scalars['Int']>;
  contacts?: Maybe<Contacts>;
  contractDetails?: Maybe<ContractDetails>;
  contractMeetingDate?: Maybe<Scalars['DateTime']>;
  coreSystem?: Maybe<CoreSystem>;
  costs?: Maybe<Costs>;
  /** This field is not available for Vitec customers. */
  countyName?: Maybe<Scalars['String']>;
  /** This field is not available for Vitec customers. */
  countyNumber?: Maybe<Scalars['Float']>;
  debt?: Maybe<Debt>;
  /** @deprecated Use `main` in `departments` instead */
  department?: Maybe<Department>;
  departments?: Maybe<Departments>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Documents>;
  easements?: Maybe<Array<Maybe<Easement>>>;
  eiendomsprofil?: Maybe<Eiendomsprofil>;
  employees?: Maybe<Employees>;
  energy?: Maybe<Energy>;
  equationDate?: Maybe<Scalars['DateTime']>;
  estateId?: Maybe<Scalars['ID']>;
  expences?: Maybe<Expences>;
  expireDate?: Maybe<Scalars['DateTime']>;
  facilities?: Maybe<Array<Maybe<Facility>>>;
  finn?: Maybe<Finn>;
  flags?: Maybe<EstateFlags>;
  floor?: Maybe<Scalars['Float']>;
  fortune?: Maybe<Fortune>;
  geodata?: Maybe<Geodata>;
  hasProjectUnits?: Maybe<Scalars['Boolean']>;
  housingCooperative?: Maybe<HousingCooperative>;
  images?: Maybe<Images>;
  inspection?: Maybe<Inspection>;
  insurance?: Maybe<Array<Maybe<Insurance>>>;
  internalSeniority?: Maybe<Scalars['Boolean']>;
  isProjectMaster?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Links>;
  localArea?: Maybe<Scalars['String']>;
  municipalityArea?: Maybe<Scalars['String']>;
  municipalityName?: Maybe<Scalars['String']>;
  municipalityNumber?: Maybe<Scalars['Int']>;
  ownerBuildingType?: Maybe<Scalars['String']>;
  ownerProperty?: Maybe<Scalars['String']>;
  ownershipType?: Maybe<Scalars['String']>;
  permalink?: Maybe<Scalars['String']>;
  plot?: Maybe<Plot>;
  postalPlace?: Maybe<Scalars['String']>;
  previewCode?: Maybe<Scalars['String']>;
  prices?: Maybe<Prices>;
  productId?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectMasterId?: Maybe<Scalars['String']>;
  projectStatistics?: Maybe<ProjectStatistics>;
  publicRelation?: Maybe<PublicRelation>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  referenceUrls?: Maybe<ReferenceUrls>;
  rentalEstimate?: Maybe<RentalEstimate>;
  requiresPermitToOvertake?: Maybe<Scalars['Boolean']>;
  rooms?: Maybe<Rooms>;
  showings?: Maybe<Showings>;
  size?: Maybe<Size>;
  snapshot?: Maybe<Snapshot>;
  sold?: Maybe<Scalars['Boolean']>;
  soldAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use `soldAt` instead */
  soldDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EstateStatus>;
  streetAddress?: Maybe<Scalars['String']>;
  /** This field is only available for Vitec customers. */
  systemId?: Maybe<Scalars['String']>;
  takeOverDate?: Maybe<Scalars['DateTime']>;
  takeoverComment?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['String']>;
  texts?: Maybe<Texts>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  valuation?: Maybe<Valuation>;
  video?: Maybe<Video>;
  /** @deprecated Use video { url } */
  videos?: Maybe<EstateVideos>;
  zipCode?: Maybe<Scalars['String']>;
};

export type EstateImagesArgs = {
  finn?: Maybe<Scalars['Boolean']>;
};

export type EstateProjectArgs = {
  input?: Maybe<ProjectInput>;
};

export type EstateFlags = DefaultEstateFlags;

export type EstateInput = {
  _id?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  estateId?: Maybe<Scalars['String']>;
  isAssignmentAccepted?: Maybe<Scalars['Boolean']>;
  preview?: Maybe<Scalars['Boolean']>;
  productDomain?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  refresh?: Maybe<Scalars['Boolean']>;
  snapshot?: Maybe<Scalars['Boolean']>;
  traceId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export enum EstateStatus {
  Reserved = 'Reserved',
  Sold = 'Sold',
  Unknown = 'Unknown',
  Vacant = 'Vacant'
}

export type EstateVideos = {
  __typename?: 'EstateVideos';
  finn?: Maybe<Video>;
};

export type Expences = {
  __typename?: 'Expences';
  annualWellFee?: Maybe<Scalars['Float']>;
  collectiveExpences?: Maybe<Scalars['Float']>;
  collectiveExpencesDescription?: Maybe<Scalars['String']>;
  collectiveExpencesPeriod?: Maybe<Period>;
  collectiveExpencesTo?: Maybe<Scalars['Float']>;
  municipalTaxes?: Maybe<Scalars['Float']>;
  municipalTaxesPeriod?: Maybe<Period>;
  municipalTaxesTo?: Maybe<Scalars['Float']>;
  municipalTaxesYear?: Maybe<Scalars['Int']>;
  propertyTax?: Maybe<Scalars['Float']>;
  propertyTaxYear?: Maybe<Scalars['Int']>;
  waterFee?: Maybe<Scalars['Float']>;
  waterFeeYear?: Maybe<Scalars['Int']>;
};

export type Facility = {
  __typename?: 'Facility';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<FacilityType>;
};

export enum FacilityType {
  AccessibilityLevel = 'AccessibilityLevel',
  Airconditioning = 'Airconditioning',
  Alarm = 'Alarm',
  AlpineSkiing = 'AlpineSkiing',
  BalancedVentilation = 'BalancedVentilation',
  Balcony = 'Balcony',
  BoatMooring = 'BoatMooring',
  Broadband = 'Broadband',
  CableTv = 'CableTV',
  Canteen = 'Canteen',
  Central = 'Central',
  ChildFriendly = 'ChildFriendly',
  Coast = 'Coast',
  CommonWashroom = 'CommonWashroom',
  DriveGate = 'DriveGate',
  ElectricCharging = 'ElectricCharging',
  Expandable = 'Expandable',
  Fireplace = 'Fireplace',
  FishingOpportunity = 'FishingOpportunity',
  Furnished = 'Furnished',
  Garage = 'Garage',
  Garden = 'Garden',
  Golf = 'Golf',
  GuestParking = 'GuestParking',
  Hiking = 'Hiking',
  Inland = 'Inland',
  JanitorSecurityServices = 'JanitorSecurityServices',
  JanitorServices = 'JanitorServices',
  Lift = 'Lift',
  LoadingRamp = 'LoadingRamp',
  MainsElectricity = 'MainsElectricity',
  MainsWater = 'MainsWater',
  Modern = 'Modern',
  Mountains = 'Mountains',
  NoNeighboursInsight = 'NoNeighboursInsight',
  Parking = 'Parking',
  Parquett = 'Parquett',
  PartlyFurnished = 'PartlyFurnished',
  PetsAllowed = 'PetsAllowed',
  PublicWaterSewer = 'PublicWaterSewer',
  QuietArea = 'QuietArea',
  Reception = 'Reception',
  RoadAccess = 'RoadAccess',
  RoofTerrace = 'RoofTerrace',
  Shading = 'Shading',
  Shoreline = 'Shoreline',
  SwimmingPossibility = 'SwimmingPossibility',
  Unfurnished = 'Unfurnished',
  Unknown = 'Unknown',
  Veranda = 'Veranda',
  View = 'View'
}

export type Features = {
  __typename?: 'Features';
  correction?: Maybe<Scalars['Boolean']>;
};

export type Finn = {
  __typename?: 'Finn';
  finnCode?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

export type FinnImage = {
  __typename?: 'FinnImage';
  description?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

export type Form = {
  __typename?: 'Form';
  consents: Array<Maybe<FormConsent>>;
  failedText?: Maybe<Scalars['String']>;
  fields: Array<Maybe<FormField>>;
  formId: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
  submitLabel?: Maybe<Scalars['String']>;
  successText?: Maybe<Scalars['String']>;
};

export type FormConsent = FormFieldCheckbox | FormFieldNewsletter | FormFieldRadio;

export type FormField =
  | FormFieldCheckbox
  | FormFieldHidden
  | FormFieldInput
  | FormFieldRadio
  | FormFieldSelect
  | FormFieldShowing
  | FormFieldTextarea;

export type FormFieldCheckbox = {
  __typename?: 'FormFieldCheckbox';
  checked?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<FormFieldError>>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type: FormFieldType;
  value?: Maybe<Scalars['String']>;
};

export type FormFieldError = {
  __typename?: 'FormFieldError';
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type FormFieldHidden = {
  __typename?: 'FormFieldHidden';
  id: Scalars['ID'];
  type: FormFieldType;
  value?: Maybe<Scalars['String']>;
};

export type FormFieldInput = {
  __typename?: 'FormFieldInput';
  errors?: Maybe<Array<Maybe<FormFieldError>>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  maxlength?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  pattern?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type: FormFieldType;
  value?: Maybe<Scalars['String']>;
};

export type FormFieldNewsletter = {
  __typename?: 'FormFieldNewsletter';
  checked?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<FormFieldError>>>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  type: FormFieldType;
  value?: Maybe<Scalars['String']>;
};

export type FormFieldRadio = {
  __typename?: 'FormFieldRadio';
  errors?: Maybe<Array<Maybe<FormFieldError>>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options: Array<Maybe<FormFieldRadioItem>>;
  required?: Maybe<Scalars['Boolean']>;
  type: FormFieldType;
};

export type FormFieldRadioItem = {
  __typename?: 'FormFieldRadioItem';
  checked?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FormFieldSelect = {
  __typename?: 'FormFieldSelect';
  errors?: Maybe<Array<Maybe<FormFieldError>>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options: Array<Maybe<FormFieldSelectOptionItem>>;
  placeholder?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type: FormFieldType;
};

export type FormFieldSelectOptionItem = {
  __typename?: 'FormFieldSelectOptionItem';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FormFieldShowing = {
  __typename?: 'FormFieldShowing';
  errors?: Maybe<Array<Maybe<FormFieldError>>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  options: Array<Maybe<FormFieldShowingOption>>;
  required?: Maybe<Scalars['Boolean']>;
  type: FormFieldType;
};

export type FormFieldShowingOption = {
  __typename?: 'FormFieldShowingOption';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FormFieldTextarea = {
  __typename?: 'FormFieldTextarea';
  errors?: Maybe<Array<Maybe<FormFieldError>>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  maxlength?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  pattern?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type: FormFieldType;
  value?: Maybe<Scalars['String']>;
};

export enum FormFieldType {
  Checkbox = 'Checkbox',
  Email = 'Email',
  Hidden = 'Hidden',
  Newsletter = 'Newsletter',
  Phone = 'Phone',
  Radio = 'Radio',
  Select = 'Select',
  Showing = 'Showing',
  Text = 'Text',
  Textarea = 'Textarea'
}

export type FormInput = {
  alias?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  estateId?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
};

export type FormSubmit = {
  __typename?: 'FormSubmit';
  message?: Maybe<Scalars['String']>;
  redirect?: Maybe<FormSubmitRedirect>;
  success: Scalars['Boolean'];
};

export type FormSubmitConsentInput = {
  checked?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export type FormSubmitFieldInput = {
  checked?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type FormSubmitInput = {
  alias?: Maybe<Scalars['String']>;
  brandId: Scalars['String'];
  consents?: Maybe<Array<Maybe<FormSubmitConsentInput>>>;
  employeeAlias?: Maybe<Scalars['String']>;
  estateId?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<FormSubmitFieldInput>>>;
  formId: Scalars['String'];
  referer?: Maybe<Scalars['String']>;
};

export type FormSubmitRedirect = {
  __typename?: 'FormSubmitRedirect';
  url?: Maybe<Scalars['String']>;
};

export type FormSubmitRedirectUrlArgs = {
  relative?: Maybe<Scalars['Boolean']>;
};

export type Fortune = {
  __typename?: 'Fortune';
  collectiveFortune?: Maybe<Scalars['Float']>;
  collectiveFortuneTo?: Maybe<Scalars['Float']>;
  totalFortune?: Maybe<Scalars['Float']>;
  totalFortuneTo?: Maybe<Scalars['Float']>;
  verifiedDate?: Maybe<Scalars['DateTime']>;
};

export enum GeoUnitType {
  Centimeters = 'centimeters',
  Feet = 'feet',
  Inch = 'inch',
  Kilometers = 'kilometers',
  Meters = 'meters',
  Miles = 'miles',
  Millimeters = 'millimeters',
  Nauticalmiles = 'nauticalmiles',
  Yards = 'yards'
}

export type Geodata = {
  __typename?: 'Geodata';
  coordinates?: Maybe<Coordinates>;
};

export type GeodataCadasterInput = {
  bnr: Scalars['Int'];
  gnr: Scalars['Int'];
  knr: Scalars['Int'];
};

export type GeodataInput = {
  address: Scalars['String'];
  cadaster: GeodataCadasterInput;
};

export type GetEstateIdInput = {
  assignmentNumber?: Maybe<Scalars['String']>;
  brandId: Scalars['ID'];
};

export type HousingCooperative = {
  __typename?: 'HousingCooperative';
  changeOfOwnershipFee?: Maybe<Scalars['Float']>;
  deposit?: Maybe<Scalars['Float']>;
  interestOnlyPeriod?: Maybe<Scalars['String']>;
  jointDebtInstallment?: Maybe<Scalars['Float']>;
  jointDebtInterest?: Maybe<Scalars['Float']>;
  jointWealthShare?: Maybe<Scalars['Float']>;
  jointWealthShareDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nominalStockValue?: Maybe<Scalars['Float']>;
  orgNumber?: Maybe<Scalars['String']>;
  ownershipFraction?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  partialBondNumber?: Maybe<Scalars['String']>;
  partialDenominatedBond?: Maybe<Scalars['String']>;
  preemptionDeadline?: Maybe<Scalars['String']>;
  preemptive?: Maybe<Scalars['String']>;
  preemptiveRightsFee?: Maybe<Scalars['Float']>;
  shareJointDebtToDate?: Maybe<Scalars['String']>;
  shareJointDebtYear?: Maybe<Scalars['Int']>;
  sharedCostsAfterInterestFreePeriod?: Maybe<Scalars['String']>;
  stockNumber?: Maybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  imageId: Scalars['ID'];
  large?: Maybe<Scalars['String']>;
  orientation?: Maybe<ImageOrientation>;
  prediction?: Maybe<Prediction>;
  thumb?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export enum ImageOrientation {
  Landscape = 'Landscape',
  Portrait = 'Portrait'
}

export type Images = {
  __typename?: 'Images';
  floorplans?: Maybe<Array<Maybe<Image>>>;
  list?: Maybe<Array<Maybe<Image>>>;
  main?: Maybe<Image>;
};

export type ImagesFloorplansArgs = {
  threshold?: Maybe<Scalars['Float']>;
};

export type ImagesListArgs = {
  first?: Maybe<Scalars['Int']>;
};

export type Index = {
  __typename?: 'Index';
  /** Trigger index of brand(s) in ElasticSearch */
  brand: Indexed;
  /** Trigger index of employees(s) in ElasticSearch */
  employee: Indexed;
  /** Trigger index of estate(s) in ElasticSearch */
  estate: Indexed;
};

export type IndexBrandArgs = {
  input?: Maybe<IndexBrandInput>;
};

export type IndexEmployeeArgs = {
  input?: Maybe<IndexEmployeeInput>;
};

export type IndexEstateArgs = {
  input?: Maybe<IndexEstateInput>;
};

export type IndexBrandInput = {
  all?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['String']>;
  filter?: Maybe<IndexFilter>;
  index?: Maybe<Scalars['String']>;
};

export type IndexEmployeeInput = {
  all?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['String']>;
  employeeAlias?: Maybe<Scalars['String']>;
  filter?: Maybe<IndexFilter>;
  index?: Maybe<Scalars['String']>;
};

export type IndexEstateInput = {
  all?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['String']>;
  coreSystem?: Maybe<Scalars['String']>;
  estateId?: Maybe<Scalars['String']>;
  filter?: Maybe<IndexFilter>;
  index?: Maybe<Scalars['String']>;
  tenant?: Maybe<Scalars['String']>;
};

export type IndexFilter = {
  enabledIndexedAt?: Maybe<Scalars['Boolean']>;
};

export type Indexed = {
  __typename?: 'Indexed';
  success?: Maybe<Scalars['Boolean']>;
};

export type Inspection = {
  __typename?: 'Inspection';
  completed?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['DateTime']>;
};

export type Insurance = {
  __typename?: 'Insurance';
  name?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  secondaryCompany?: Maybe<Scalars['String']>;
};

export type LabelValue = {
  __typename?: 'LabelValue';
  label?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Layout = {
  __typename?: 'Layout';
  allowedOrigins?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  favicon?: Maybe<Scalars['String']>;
  gtm?: Maybe<Scalars['String']>;
  html?: Maybe<SiteHtml>;
  logo?: Maybe<Scalars['String']>;
  menu?: Maybe<Menu>;
  page: Page;
  seo?: Maybe<PageSeo>;
  site?: Maybe<Scalars['JSON']>;
  style?: Maybe<Scalars['JSON']>;
};

export type LayoutPageArgs = {
  input: PageInput;
};

export type LayoutSeoArgs = {
  input: PageInput;
};

export type Link = {
  __typename?: 'Link';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  linkId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Links = {
  __typename?: 'Links';
  list: Array<Maybe<Link>>;
  private: Array<Maybe<Link>>;
  public: Array<Maybe<Link>>;
};

export type LogOutResponse = {
  __typename?: 'LogOutResponse';
  success: Scalars['Boolean'];
};

export type LoginInput = {
  email?: Maybe<Scalars['String']>;
  env?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  expireAt?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type LoginSendNewCodeResponse = {
  __typename?: 'LoginSendNewCodeResponse';
  success: Scalars['Boolean'];
};

export type LoginVerifyCodeInput = {
  env?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  pin: Scalars['String'];
};

export type LoginVerifyCodeResponse = {
  __typename?: 'LoginVerifyCodeResponse';
  redirect?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  token: Scalars['String'];
};

export type McvBkgImg = {
  __typename?: 'McvBkgImg';
  _id: Scalars['String'];
  name: Scalars['String'];
  selected?: Maybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type McvExperienceConfig = {
  __typename?: 'McvExperienceConfig';
  active?: Maybe<Scalars['Boolean']>;
  desc?: Maybe<McvField>;
  helperText?: Maybe<Scalars['String']>;
  location?: Maybe<McvField>;
};

export type McvExperienceInput = {
  fromYear: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  toYear?: Maybe<Scalars['Int']>;
  type?: Maybe<McvExperienceType>;
};

export type McvExperienceItem = {
  __typename?: 'McvExperienceItem';
  _id: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  fromYear: Scalars['Int'];
  location?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  toYear?: Maybe<Scalars['Int']>;
  type?: Maybe<McvExperienceType>;
};

export enum McvExperienceType {
  Education = 'education',
  Unknown = 'unknown',
  Work = 'work'
}

export type McvFeedbackConfig = {
  __typename?: 'McvFeedbackConfig';
  active?: Maybe<Scalars['Boolean']>;
  customer?: Maybe<McvField>;
  desc?: Maybe<McvField>;
  helperText?: Maybe<Scalars['String']>;
};

export type McvFeedbackInput = {
  customer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type McvFeedbackItem = {
  __typename?: 'McvFeedbackItem';
  _id: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  customer?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type McvField = {
  __typename?: 'McvField';
  isRequired?: Maybe<Scalars['Boolean']>;
  maxLength?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
};

export type McvFrontendContentItem = {
  __typename?: 'McvFrontendContentItem';
  pos?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type McvFrontendInput = {
  brandId: Scalars['String'];
  fields?: Maybe<Array<Scalars['String']>>;
  officeTag?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

export type McvFrontendItem = {
  __typename?: 'McvFrontendItem';
  content?: Maybe<Array<McvFrontendContentItem>>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type McvFrontendResult = {
  __typename?: 'McvFrontendResult';
  count: Scalars['Int'];
  fields?: Maybe<Array<Maybe<McvFrontendItem>>>;
};

export type McvListInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  sortAscending?: Maybe<Scalars['Boolean']>;
  sortOrderBy?: Maybe<McvListOrderBy>;
  value?: Maybe<Scalars['String']>;
};

export enum McvListOrderBy {
  CreatedAt = 'createdAt',
  Name = 'name',
  Role = 'role',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type McvListResponse = {
  __typename?: 'McvListResponse';
  count?: Maybe<Scalars['Int']>;
  list?: Maybe<Array<McvProfileListItem>>;
};

export type McvMsgItem = {
  __typename?: 'McvMsgItem';
  active?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type McvPdfItem = {
  __typename?: 'McvPdfItem';
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type McvProfileBkgImg = {
  __typename?: 'McvProfileBkgImg';
  _id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type McvProfileDraftInput = {
  brandId: Scalars['String'];
  profileId: Scalars['String'];
};

export type McvProfileIdInput = {
  profileId: Scalars['String'];
};

export type McvProfileInput = {
  brandId: Scalars['String'];
  type: UserValueType;
  value: Scalars['String'];
};

export type McvProfileItem = {
  __typename?: 'McvProfileItem';
  _id: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  bkgImg?: Maybe<McvProfileBkgImg>;
  email?: Maybe<Scalars['String']>;
  employeeAlias?: Maybe<Scalars['String']>;
  exp?: Maybe<Array<McvExperienceItem>>;
  feedback?: Maybe<Array<McvFeedbackItem>>;
  img?: Maybe<Scalars['String']>;
  leisure?: Maybe<Array<McvProfileText>>;
  myPartners?: Maybe<Array<McvProfileText>>;
  name: Scalars['String'];
  profile?: Maybe<Array<McvProfileText>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  quiz?: Maybe<Array<McvQuizAnswer>>;
  video?: Maybe<McvVideoItem>;
  work?: Maybe<Array<McvProfileText>>;
};

export type McvProfileListItem = {
  __typename?: 'McvProfileListItem';
  _id: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  approved?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  published?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  seekingApproval?: Maybe<Scalars['Boolean']>;
  status?: Maybe<McvStatusItem>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type McvProfileResponse = {
  __typename?: 'McvProfileResponse';
  profile?: Maybe<McvProfileItem>;
};

export type McvProfileText = {
  __typename?: 'McvProfileText';
  _id: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type McvProfileUpdateImageInput = {
  imageUrl?: Maybe<Scalars['String']>;
  profileId: Scalars['String'];
};

export type McvProfileUpdateInput = {
  bkgImgId: Scalars['String'];
  exp?: Maybe<Array<McvExperienceInput>>;
  feedback?: Maybe<Array<McvFeedbackInput>>;
  leisure?: Maybe<Array<McvTextInput>>;
  myPartners?: Maybe<Array<McvTextInput>>;
  profile?: Maybe<Array<McvTextInput>>;
  profileId?: Maybe<Scalars['String']>;
  quiz?: Maybe<Array<McvQuizAnswerInput>>;
  templateId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  work?: Maybe<Array<McvTextInput>>;
};

export type McvProfileUpdateResponse = {
  __typename?: 'McvProfileUpdateResponse';
  profileId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type McvQuizAnswer = {
  __typename?: 'McvQuizAnswer';
  answer: Scalars['String'];
  question: Scalars['String'];
  quiestionId: Scalars['String'];
  quizId: Scalars['String'];
};

export type McvQuizAnswerInput = {
  answer: Scalars['String'];
  question: Scalars['String'];
  quiestionId: Scalars['String'];
  quizId: Scalars['String'];
};

export type McvStatus = {
  __typename?: 'McvStatus';
  active: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  config?: Maybe<McvStatusConfig>;
  isDefault?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
};

export type McvStatusConfig = {
  __typename?: 'McvStatusConfig';
  btnCvDraft?: Maybe<Scalars['Boolean']>;
  btnCvLive?: Maybe<Scalars['Boolean']>;
  btnDelete?: Maybe<Scalars['Boolean']>;
  btnPublish?: Maybe<Scalars['Boolean']>;
  btnSeekApproval?: Maybe<Scalars['Boolean']>;
};

export type McvStatusInput = {
  color?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type McvStatusItem = {
  __typename?: 'McvStatusItem';
  color?: Maybe<Scalars['String']>;
  config?: Maybe<McvStatusConfig>;
  name: Scalars['String'];
};

export type McvSuccessResult = {
  __typename?: 'McvSuccessResult';
  success: Scalars['Boolean'];
};

export type McvTempHelpers = {
  __typename?: 'McvTempHelpers';
  experience?: Maybe<Scalars['String']>;
  leisure?: Maybe<Scalars['String']>;
  partners?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
};

export type McvTempQuestion = {
  __typename?: 'McvTempQuestion';
  _id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  position?: Maybe<Scalars['Int']>;
  question?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
};

export type McvTempQuiz = {
  __typename?: 'McvTempQuiz';
  _id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  answer?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<McvTempQuestion>>;
};

export type McvTemplateConfig = {
  __typename?: 'McvTemplateConfig';
  bkgImgsIsRequired: Scalars['Boolean'];
  experience?: Maybe<McvExperienceConfig>;
  feedback?: Maybe<McvFeedbackConfig>;
  headerInfo?: Maybe<Scalars['String']>;
  msg?: Maybe<McvMsgItem>;
};

export type McvTemplateInput = {
  brandId?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
};

export type McvTemplateItem = {
  __typename?: 'McvTemplateItem';
  _id: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  bkgImgs?: Maybe<Array<McvBkgImg>>;
  brandId: Scalars['String'];
  config?: Maybe<McvTemplateConfig>;
  createdAt: Scalars['Date'];
  currentStatus?: Maybe<McvStatus>;
  draftUrl?: Maybe<Scalars['String']>;
  exp?: Maybe<Array<McvExperienceItem>>;
  feedback?: Maybe<Array<McvFeedbackItem>>;
  helpers?: Maybe<McvTempHelpers>;
  leisure?: Maybe<Array<McvTextItem>>;
  liveUrl?: Maybe<Scalars['String']>;
  myPartners?: Maybe<Array<McvTextItem>>;
  name?: Maybe<Scalars['String']>;
  profile?: Maybe<Array<McvTextItem>>;
  profileId?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  quiz?: Maybe<Array<McvTempQuiz>>;
  seekingApproval?: Maybe<Scalars['Boolean']>;
  statuses?: Maybe<Array<McvStatus>>;
  videoLink?: Maybe<McvVideoLink>;
  work?: Maybe<Array<McvTextItem>>;
};

export type McvTemplateResponse = {
  __typename?: 'McvTemplateResponse';
  success: Scalars['Boolean'];
  template?: Maybe<McvTemplateItem>;
};

export type McvTextInput = {
  id: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type McvTextItem = {
  __typename?: 'McvTextItem';
  _id: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  maxSize?: Maybe<Scalars['Int']>;
  placeHolder?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type McvVideoItem = {
  __typename?: 'McvVideoItem';
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  videoId?: Maybe<Scalars['String']>;
};

export type McvVideoLink = {
  __typename?: 'McvVideoLink';
  _id: Scalars['String'];
  active?: Maybe<Scalars['Boolean']>;
  helperText?: Maybe<Scalars['String']>;
  isRequired: Scalars['Boolean'];
  maxSeconds?: Maybe<Scalars['Int']>;
  pdf?: Maybe<McvPdfItem>;
  validLink?: Maybe<Array<Scalars['String']>>;
  value?: Maybe<Scalars['String']>;
};

export type Menu = {
  __typename?: 'Menu';
  list?: Maybe<Array<Maybe<MenuItem>>>;
};

export type MenuInput = {
  brandId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  attributes?: Maybe<MenuItemAttributes>;
  href?: Maybe<Scalars['String']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Maybe<MenuItem>>>;
  target?: Maybe<Scalars['String']>;
};

export type MenuItemAttributes = {
  __typename?: 'MenuItemAttributes';
  className?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  dsApprove?: Maybe<DsApproveResponse>;
  dsAttachmentReorder?: Maybe<DsAttachmentReorder>;
  dsAttachmentSelect?: Maybe<DsAttachmentSelect>;
  dsCommentAdd: DsCommentAddResponse;
  dsCommentPositionUpdate?: Maybe<DsCommentPositionUpdateResponse>;
  dsCommentRemove?: Maybe<DsCommentRemoveResponse>;
  dsCommentResolve?: Maybe<DsCommentResolveResponse>;
  dsCommentUpdate?: Maybe<DsCommentUpdateResponse>;
  dsCorrectionDone?: Maybe<CorrectionDoneResponse>;
  dsCorrectionInitial?: Maybe<CorrectionInitialResponse>;
  dsCorrectionResolved?: Maybe<CorrectionResolvedResponse>;
  dsCorrectionStartNew?: Maybe<CorrectionStartNewResponse>;
  dsPendingCustomer?: Maybe<DsPendingCustomerResponse>;
  form?: Maybe<FormSubmit>;
  index?: Maybe<Index>;
  login: LoginResponse;
  loginNewCode: LoginSendNewCodeResponse;
  loginVerifyCode: LoginVerifyCodeResponse;
  logout?: Maybe<LogOutResponse>;
  mcvProfileDeactivate: McvSuccessResult;
  mcvProfilePublish: McvSuccessResult;
  mcvProfileSeekApproval: McvSuccessResult;
  mcvProfileUpdate: McvProfileUpdateResponse;
  mcvProfileUpdateImage: McvSuccessResult;
};

export type MutationDsApproveArgs = {
  input: DsApproveInput;
};

export type MutationDsAttachmentReorderArgs = {
  input: DsAttachmentReorderInput;
};

export type MutationDsAttachmentSelectArgs = {
  input: DsAttachmentSelectInput;
};

export type MutationDsCommentAddArgs = {
  input: DsCommentAddInput;
};

export type MutationDsCommentPositionUpdateArgs = {
  input: DsCommentPositionUpdateInput;
};

export type MutationDsCommentRemoveArgs = {
  input: DsCommentRemoveInput;
};

export type MutationDsCommentResolveArgs = {
  input: DsCommentResolveInput;
};

export type MutationDsCommentUpdateArgs = {
  input: DsCommentUpdateInput;
};

export type MutationDsCorrectionDoneArgs = {
  input: CorrectionDoneInput;
};

export type MutationDsCorrectionInitialArgs = {
  input: CorrectionInitialInput;
};

export type MutationDsCorrectionResolvedArgs = {
  input: CorrectionResolvedInput;
};

export type MutationDsCorrectionStartNewArgs = {
  input: CorrectionStartNewInput;
};

export type MutationDsPendingCustomerArgs = {
  input: DsPendingCustomerInput;
};

export type MutationFormArgs = {
  input: FormSubmitInput;
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationLoginNewCodeArgs = {
  input: LoginSendNewCodeInput;
};

export type MutationLoginVerifyCodeArgs = {
  input: LoginVerifyCodeInput;
};

export type MutationMcvProfileDeactivateArgs = {
  input: McvProfileIdInput;
};

export type MutationMcvProfilePublishArgs = {
  input: McvProfileIdInput;
};

export type MutationMcvProfileSeekApprovalArgs = {
  input: McvProfileIdInput;
};

export type MutationMcvProfileUpdateArgs = {
  input: McvProfileUpdateInput;
};

export type MutationMcvProfileUpdateImageArgs = {
  input: McvProfileUpdateImageInput;
};

export type Page = {
  __typename?: 'Page';
  alias?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  children?: Maybe<Scalars['JSON']>;
  component?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Maybe<PageComponent>>>;
  layout?: Maybe<PageLayout>;
  params?: Maybe<Array<Maybe<PageParam>>>;
  props?: Maybe<Scalars['JSON']>;
  style?: Maybe<Scalars['JSON']>;
};

export type PageComponent = {
  __typename?: 'PageComponent';
  component?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Maybe<PageComponent>>>;
  props?: Maybe<Scalars['JSON']>;
  style?: Maybe<Scalars['JSON']>;
};

export type PageFooter = {
  __typename?: 'PageFooter';
  component?: Maybe<Scalars['String']>;
  props?: Maybe<Scalars['JSON']>;
  style?: Maybe<Scalars['JSON']>;
};

export type PageHeader = {
  __typename?: 'PageHeader';
  component?: Maybe<Scalars['String']>;
  props?: Maybe<Scalars['JSON']>;
  style?: Maybe<Scalars['JSON']>;
};

export type PageInput = {
  preview?: Maybe<Scalars['Boolean']>;
  query: PageInputQuery;
};

export type PageInputQuery = {
  route: Array<Maybe<Scalars['String']>>;
};

export type PageLayout = {
  __typename?: 'PageLayout';
  component?: Maybe<Scalars['String']>;
  footer?: Maybe<PageFooter>;
  header?: Maybe<PageHeader>;
};

export type PageParam = {
  __typename?: 'PageParam';
  key?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PageSeo = {
  __typename?: 'PageSeo';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type PaginationInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type Parking = {
  __typename?: 'Parking';
  description?: Maybe<Scalars['String']>;
  estateId?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<ParkingFacility>>;
  included?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parkingId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  saleType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusDescription?: Maybe<Scalars['String']>;
  type?: Maybe<ParkingType>;
  typeDescription?: Maybe<Scalars['String']>;
};

export type ParkingFacility = {
  __typename?: 'ParkingFacility';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum ParkingType {
  Garage = 'garage',
  Motorcycle = 'motorcycle',
  ParkingSpace = 'parkingSpace',
  StreetParking = 'streetParking',
  Unknown = 'unknown'
}

export enum Period {
  Day = 'Day',
  HalfYear = 'HalfYear',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export type Plot = {
  __typename?: 'Plot';
  lease?: Maybe<PlotLease>;
  owned?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Float']>;
};

export type PlotLease = {
  __typename?: 'PlotLease';
  annualFee?: Maybe<Scalars['Float']>;
  fromDate?: Maybe<Scalars['DateTime']>;
  isContractAnnulable?: Maybe<Scalars['Boolean']>;
  isContractTransferApproved?: Maybe<Scalars['Boolean']>;
  toDate?: Maybe<Scalars['DateTime']>;
  transferFee?: Maybe<Scalars['Float']>;
};

export enum PortalUserRole {
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  User = 'User'
}

export type Prediction = {
  __typename?: 'Prediction';
  label?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
};

export type PredictionInput = {
  category?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type PricelistItem = {
  __typename?: 'PricelistItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type Prices = {
  __typename?: 'Prices';
  askingAndSoldPriceDifference?: Maybe<Scalars['Float']>;
  askingAndSoldPriceDifferenceTo?: Maybe<Scalars['Float']>;
  askingPrice?: Maybe<Scalars['Float']>;
  askingPriceTo?: Maybe<Scalars['Float']>;
  pricePerPrimaryArea?: Maybe<Scalars['Float']>;
  pricePerPrimaryAreaTo?: Maybe<Scalars['Float']>;
  soldPrice?: Maybe<Scalars['Float']>;
  soldPriceTo?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceTo?: Maybe<Scalars['Float']>;
  totalPriceWithoutCost?: Maybe<Scalars['Float']>;
  totalPriceWithoutCostTo?: Maybe<Scalars['Float']>;
};

export type Print = {
  __typename?: 'Print';
  QrPoster?: Maybe<QrPoster>;
};

export type PrintInput = {
  brandId?: Maybe<Scalars['String']>;
  estateId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
  traceId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type PrivatmeglerenCustomChecklist = {
  __typename?: 'PrivatmeglerenCustomChecklist';
  isDoubleInsurance?: Maybe<Scalars['Boolean']>;
  isDownsized?: Maybe<Scalars['Boolean']>;
  isEvent?: Maybe<Scalars['Boolean']>;
  isNotis?: Maybe<Scalars['Boolean']>;
  isTeaser?: Maybe<Scalars['Boolean']>;
};

export type PrivatmeglerenCustomTexts = {
  __typename?: 'PrivatmeglerenCustomTexts';
  /** Custom sales statement text used on some object pages on privatmegleren.no (example: 3544450) */
  customSalesStatementText?: Maybe<TextItem>;
};

export type Project = {
  __typename?: 'Project';
  description?: Maybe<Scalars['String']>;
  details?: Maybe<ProjectDetails>;
  exampleUnit?: Maybe<ProjectUnit>;
  name?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  phases?: Maybe<Array<ProjectPhase>>;
  statistics?: Maybe<ProjectStatistics>;
  units?: Maybe<Array<ProjectUnit>>;
  website?: Maybe<Scalars['String']>;
};

export type ProjectDetails = {
  __typename?: 'ProjectDetails';
  completion?: Maybe<Scalars['String']>;
  garageParking?: Maybe<Scalars['String']>;
  miscellaneous?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  zoning?: Maybe<Scalars['String']>;
};

export type ProjectInput = {
  filter?: Maybe<ProjectUnitFilter>;
  pagination?: Maybe<PaginationInput>;
};

export type ProjectPhase = {
  __typename?: 'ProjectPhase';
  current?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  type?: Maybe<ProjectPhaseType>;
};

export enum ProjectPhaseType {
  BuildStart = 'buildStart',
  Planning = 'planning',
  SaleStart = 'saleStart',
  Takeover = 'takeover'
}

export type ProjectStatistics = {
  __typename?: 'ProjectStatistics';
  available?: Maybe<Scalars['Int']>;
  sold?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type ProjectUnit = {
  __typename?: 'ProjectUnit';
  apartmentNumber?: Maybe<Scalars['String']>;
  assignmentNumber?: Maybe<Scalars['String']>;
  costs?: Maybe<Costs>;
  debt?: Maybe<Debt>;
  estateId: Scalars['String'];
  expences?: Maybe<Expences>;
  floor?: Maybe<Scalars['Int']>;
  housingCooperative?: Maybe<HousingCooperative>;
  images?: Maybe<Images>;
  ownershipType?: Maybe<Scalars['String']>;
  parking?: Maybe<Array<Parking>>;
  plot?: Maybe<Plot>;
  prices?: Maybe<Prices>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use `publishedAt` instead */
  publishedDate?: Maybe<Scalars['DateTime']>;
  referenceUrls?: Maybe<ReferenceUrls>;
  rooms?: Maybe<Rooms>;
  size?: Maybe<Size>;
  sold?: Maybe<Scalars['Boolean']>;
  soldAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use `soldAt` instead */
  soldDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProjectUnitFilter = {
  all?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<UnitSort>;
  status?: Maybe<StringFilterInput>;
};

export enum ProjectUnitStatus {
  Reserved = 'Reserved',
  Sold = 'Sold',
  Unknown = 'Unknown',
  Vacant = 'Vacant'
}

export type PublicRelation = {
  __typename?: 'PublicRelation';
  ancestralProperty?: Maybe<Scalars['Boolean']>;
  completionCertificateDate?: Maybe<Scalars['String']>;
  landOwnerEstateDocumentDate?: Maybe<Scalars['String']>;
  liveAndManagementDuty?: Maybe<Scalars['Boolean']>;
  requiresConcession?: Maybe<Scalars['Boolean']>;
};

export type PublishedAtFilter = {
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type QrPoster = {
  __typename?: 'QrPoster';
  url?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  authenticated?: Maybe<AuthenticatedResponse>;
  department?: Maybe<Department>;
  dsComment?: Maybe<Comment>;
  dsComments?: Maybe<Comments>;
  dsSettings?: Maybe<DsSettings>;
  dsText?: Maybe<DsTextItem>;
  employee?: Maybe<Employee>;
  estate: Estate;
  form?: Maybe<Form>;
  geodata: Geodata;
  getEstateId?: Maybe<Scalars['String']>;
  layout?: Maybe<Layout>;
  mcvFrontend: McvFrontendResult;
  mcvProfile?: Maybe<McvProfileResponse>;
  mcvProfileDraft?: Maybe<McvProfileResponse>;
  mcvProfileList: McvListResponse;
  mcvTemplate?: Maybe<McvTemplateResponse>;
  menu?: Maybe<Menu>;
  portalInitialize?: Maybe<PortalInitializeResponse>;
  portalMenu: PortalMenuResponse;
  print?: Maybe<Print>;
  search: Search;
  shortUrl?: Maybe<ShortUrl>;
  version?: Maybe<Scalars['String']>;
};

export type QueryDepartmentArgs = {
  input: DepartmentInput;
};

export type QueryDsCommentArgs = {
  input: DsCommentInput;
};

export type QueryDsCommentsArgs = {
  input: DsCommentsInput;
};

export type QueryDsSettingsArgs = {
  input: DsSettingsInput;
};

export type QueryDsTextArgs = {
  input: DsTextsInput;
};

export type QueryEmployeeArgs = {
  input: EmployeeInput;
};

export type QueryEstateArgs = {
  input: EstateInput;
};

export type QueryFormArgs = {
  input: FormInput;
};

export type QueryGeodataArgs = {
  input?: Maybe<GeodataInput>;
};

export type QueryGetEstateIdArgs = {
  input: GetEstateIdInput;
};

export type QueryMcvFrontendArgs = {
  input: McvFrontendInput;
};

export type QueryMcvProfileArgs = {
  input: McvProfileInput;
};

export type QueryMcvProfileDraftArgs = {
  input: McvProfileDraftInput;
};

export type QueryMcvProfileListArgs = {
  input: McvListInput;
};

export type QueryMcvTemplateArgs = {
  input?: Maybe<McvTemplateInput>;
};

export type QueryMenuArgs = {
  input?: Maybe<MenuInput>;
};

export type QueryPrintArgs = {
  input: PrintInput;
};

export type QuerySearchArgs = {
  input: SearchInput;
};

export type QueryShortUrlArgs = {
  input: ShortUrlInput;
};

export type ReferenceUrls = {
  __typename?: 'ReferenceUrls';
  biddingAlertUrl?: Maybe<Scalars['String']>;
  biddingUrl?: Maybe<Scalars['String']>;
  estatePickerUrl?: Maybe<Scalars['String']>;
  estateUrl?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  orderProspectUrl?: Maybe<Scalars['String']>;
  pricelistUrl?: Maybe<Scalars['String']>;
  privacyStatementUrl?: Maybe<Scalars['String']>;
  projectHomepageUrl?: Maybe<Scalars['String']>;
  showingUrl?: Maybe<Scalars['String']>;
  soldPriceUrl?: Maybe<Scalars['String']>;
  stakeholderUrl?: Maybe<Scalars['String']>;
  valuationUrl?: Maybe<Scalars['String']>;
};

export type RentalEstimate = {
  __typename?: 'RentalEstimate';
  confidenceLevel?: Maybe<Scalars['Float']>;
  propertyIdNma?: Maybe<Scalars['String']>;
  rentalEstimate?: Maybe<Scalars['Float']>;
  rentalEstimateLowerBound?: Maybe<Scalars['Float']>;
  rentalEstimateUpperBound?: Maybe<Scalars['Float']>;
};

export enum Role {
  Assistant = 'assistant',
  Associate = 'associate',
  Buyer = 'buyer',
  BuyerOwner = 'buyerOwner',
  Ceo = 'ceo',
  Cooperative = 'cooperative',
  Main = 'main',
  Responsible = 'responsible',
  Seller = 'seller',
  SellerOwner = 'sellerOwner',
  Settlement = 'settlement',
  Titleholder = 'titleholder',
  Unit = 'unit',
  Unknown = 'unknown'
}

export type Rooms = {
  __typename?: 'Rooms';
  bathrooms?: Maybe<Scalars['Int']>;
  bathroomsTo?: Maybe<Scalars['Int']>;
  bedrooms?: Maybe<Scalars['Int']>;
  bedroomsTo?: Maybe<Scalars['Int']>;
  livingrooms?: Maybe<Scalars['Int']>;
  livingroomsTo?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  totalTo?: Maybe<Scalars['Int']>;
};

export type Search = {
  __typename?: 'Search';
  brand?: Maybe<SearchResultBrand>;
  employee?: Maybe<SearchResultEmployee>;
  estate?: Maybe<SearchResultEstate>;
};

export type SearchBrandArgs = {
  filter?: Maybe<SearchFilterBrand>;
};

export type SearchEmployeeArgs = {
  filter?: Maybe<SearchFilterEmployee>;
};

export type SearchEstateArgs = {
  filter?: Maybe<SearchFilterEstate>;
};

export type SearchAggregation = {
  __typename?: 'SearchAggregation';
  count?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  parentKey?: Maybe<Scalars['String']>;
};

export type SearchEstateAggregations = {
  __typename?: 'SearchEstateAggregations';
  assignmentTypes?: Maybe<Array<Maybe<SearchAggregation>>>;
  bedrooms?: Maybe<Array<Maybe<SearchAggregation>>>;
  counties?: Maybe<Array<Maybe<SearchAggregation>>>;
  estateTypes?: Maybe<Array<Maybe<SearchAggregation>>>;
  facilities?: Maybe<Array<Maybe<SearchAggregation>>>;
  geoBounds?: Maybe<SearchGeoBound>;
  geoCentroid?: Maybe<SearchGeoCentroid>;
  municipalities?: Maybe<Array<Maybe<SearchAggregation>>>;
  ownershipTypes?: Maybe<Array<Maybe<SearchAggregation>>>;
  projectStatistics?: Maybe<SearchProjectStatistics>;
  sold?: Maybe<Array<Maybe<SearchAggregation>>>;
  suburbs?: Maybe<Array<Maybe<SearchAggregation>>>;
};

export enum SearchEstateSort {
  DistanceAsc = 'DistanceAsc',
  DistanceDesc = 'DistanceDesc',
  PriceHighLow = 'PriceHighLow',
  PriceLowHigh = 'PriceLowHigh',
  PublishedNewOld = 'PublishedNewOld',
  PublishedOldNew = 'PublishedOldNew',
  RecentlySold = 'RecentlySold',
  ShowingThisWeek = 'ShowingThisWeek',
  ShowingToday = 'ShowingToday',
  ShowingTomorrow = 'ShowingTomorrow',
  SizeHighLow = 'SizeHighLow',
  SizeLowHigh = 'SizeLowHigh'
}

export type SearchFilterBrand = {
  aggregations?: Maybe<Scalars['Boolean']>;
  geo?: Maybe<SearchFilterBrandGeo>;
  include?: Maybe<SearchFilterIncludeBrand>;
  pagination?: Maybe<PaginationInput>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type SearchFilterBrandGeo = {
  lat?: Maybe<Scalars['Int']>;
  lon?: Maybe<Scalars['Int']>;
};

export type SearchFilterEmployee = {
  brandTags?: Maybe<Array<Scalars['String']>>;
  pagination?: Maybe<PaginationInput>;
};

export type SearchFilterEstate = {
  aggregations?: Maybe<Scalars['Boolean']>;
  assignmentTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  available?: Maybe<Scalars['Boolean']>;
  bedrooms?: Maybe<SearchFilterEstatePrice>;
  counties?: Maybe<Array<Maybe<Scalars['String']>>>;
  departmentAliases?: Maybe<Array<Maybe<Scalars['String']>>>;
  employeeAliases?: Maybe<Array<Maybe<Scalars['String']>>>;
  estateTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Use the aggregated facility value */
  facilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Use the enum facility Type value */
  facilityTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  geo?: Maybe<SearchFilterGeo>;
  isProjectMaster?: Maybe<Scalars['Boolean']>;
  isProjectUnit?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<SearchFilterLocation>>;
  municipalities?: Maybe<Array<Maybe<Scalars['String']>>>;
  ownershipTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  pagination?: Maybe<PaginationInput>;
  price?: Maybe<SearchFilterEstatePrice>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<PublishedAtFilter>;
  size?: Maybe<SearchFilterEstateSize>;
  sold?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<SearchEstateSort>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SearchFilterEstatePrice = {
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
};

export type SearchFilterEstateSize = {
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
};

export type SearchFilterGeo = {
  boundingBox?: Maybe<SearchFilterGeoBoundingBox>;
  distance?: Maybe<SearchFilterGeoDistance>;
  sort?: Maybe<SearchFilterGeoCoordinates>;
};

export type SearchFilterGeoBoundingBox = {
  bottomRight?: Maybe<SearchFilterGeoCoordinates>;
  topLeft?: Maybe<SearchFilterGeoCoordinates>;
};

export type SearchFilterGeoCoordinates = {
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

export type SearchFilterGeoDistance = {
  distance?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  unitType?: Maybe<GeoUnitType>;
};

export type SearchFilterIncludeBrand = {
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SearchFilterLocation = {
  county?: Maybe<Scalars['String']>;
  municipalities?: Maybe<Array<Scalars['String']>>;
  suburbs?: Maybe<Array<Scalars['String']>>;
};

export type SearchGeoBound = {
  __typename?: 'SearchGeoBound';
  bottomRight?: Maybe<SearchGeoLatLon>;
  topLeft?: Maybe<SearchGeoLatLon>;
};

export type SearchGeoCentroid = {
  __typename?: 'SearchGeoCentroid';
  count?: Maybe<Scalars['Int']>;
  location?: Maybe<SearchGeoLatLon>;
};

export type SearchGeoLatLon = {
  __typename?: 'SearchGeoLatLon';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
};

export type SearchInput = {
  brandId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  traceId?: Maybe<Scalars['String']>;
};

export type SearchProjectStatistics = {
  __typename?: 'SearchProjectStatistics';
  projectCount?: Maybe<Scalars['Int']>;
  unitsAvailable?: Maybe<Scalars['Int']>;
  unitsSold?: Maybe<Scalars['Int']>;
  unitsTotal?: Maybe<Scalars['Int']>;
};

export type SearchResultBrand = {
  __typename?: 'SearchResultBrand';
  aggregations?: Maybe<BrandAggregations>;
  list: Array<Maybe<Department>>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchResultEmployee = {
  __typename?: 'SearchResultEmployee';
  list: Array<Maybe<Employee>>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchResultEstate = {
  __typename?: 'SearchResultEstate';
  aggregations?: Maybe<SearchEstateAggregations>;
  list: Array<Maybe<Estate>>;
  pagination?: Maybe<Pagination>;
  total?: Maybe<Scalars['Int']>;
};

export type ShortUrl = {
  __typename?: 'ShortUrl';
  generate?: Maybe<ShortUrlGenerate>;
  info?: Maybe<Scalars['JSON']>;
  remove?: Maybe<ShortUrlRemove>;
};

export type ShortUrlGenerate = {
  __typename?: 'ShortUrlGenerate';
  code?: Maybe<Scalars['String']>;
};

export type ShortUrlInput = {
  code?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ShortUrlRemove = {
  __typename?: 'ShortUrlRemove';
  success?: Maybe<Scalars['Boolean']>;
};

export type Showing = {
  __typename?: 'Showing';
  endDate: Scalars['DateTime'];
  maxParticipants?: Maybe<Scalars['Int']>;
  showingId: Scalars['ID'];
  startDate: Scalars['DateTime'];
};

export type Showing3d = {
  __typename?: 'Showing3d';
  url?: Maybe<Scalars['String']>;
};

export type Showings = {
  __typename?: 'Showings';
  list?: Maybe<Array<Maybe<Showing>>>;
  note?: Maybe<Scalars['String']>;
  showing3d?: Maybe<Showing3d>;
};

export type SiteHtml = {
  __typename?: 'SiteHtml';
  body?: Maybe<Scalars['JSON']>;
  head?: Maybe<Scalars['JSON']>;
};

export type Size = {
  __typename?: 'Size';
  enclosedBalconyArea?: Maybe<Scalars['Float']>;
  enclosedBalconyAreaTo?: Maybe<Scalars['Float']>;
  grossArea?: Maybe<Scalars['Float']>;
  grossAreaTo?: Maybe<Scalars['Float']>;
  grossExternalArea?: Maybe<Scalars['Float']>;
  grossExternalAreaTo?: Maybe<Scalars['Float']>;
  grossInternalArea?: Maybe<Scalars['Float']>;
  grossInternalAreaTo?: Maybe<Scalars['Float']>;
  lowCeilingArea?: Maybe<Scalars['Float']>;
  openArea?: Maybe<Scalars['Float']>;
  openAreaTo?: Maybe<Scalars['Float']>;
  primaryArea?: Maybe<Scalars['Float']>;
  primaryAreaTo?: Maybe<Scalars['Float']>;
  totalFloorArea?: Maybe<Scalars['Float']>;
  usableArea?: Maybe<Scalars['Float']>;
  usableAreaTo?: Maybe<Scalars['Float']>;
};

export type Snapshot = {
  __typename?: 'Snapshot';
  createdAt?: Maybe<Scalars['DateTime']>;
  statusCode?: Maybe<Scalars['Int']>;
  statusMessage?: Maybe<Scalars['String']>;
  traceId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type StatItem = {
  __typename?: 'StatItem';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type StringFilterInput = {
  exclude?: Maybe<Array<Scalars['String']>>;
  include?: Maybe<Array<Scalars['String']>>;
};

export type Text = {
  __typename?: 'Text';
  heading?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type TextGroup = {
  __typename?: 'TextGroup';
  list: Array<Maybe<TextSubGroup>>;
  name?: Maybe<Scalars['String']>;
};

export type TextItem = {
  __typename?: 'TextItem';
  category?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type TextSubGroup = {
  __typename?: 'TextSubGroup';
  heading?: Maybe<Scalars['String']>;
  list: Array<Maybe<Text>>;
};

export type Texts = {
  __typename?: 'Texts';
  custom?: Maybe<CustomTexts>;
  groups: Array<Maybe<TextGroup>>;
  hasDynamicText?: Maybe<Scalars['Boolean']>;
  intro?: Maybe<TextItem>;
  list: Array<Maybe<TextItem>>;
};

export enum TwoFactor {
  Email = 'email',
  Sms = 'sms'
}

export enum UnitSort {
  AskingpriceAsc = 'AskingpriceAsc',
  AskingpriceDesc = 'AskingpriceDesc',
  Default = 'Default',
  StatusAsc = 'StatusAsc',
  StatusDesc = 'StatusDesc',
  TotalpriceAsc = 'TotalpriceAsc',
  TotalpriceDesc = 'TotalpriceDesc'
}

export enum UserRole {
  Admin = 'admin',
  Broker = 'broker',
  Seller = 'seller',
  Superadmin = 'superadmin'
}

export enum UserValueType {
  Alias = 'alias',
  Email = 'email',
  ExternalId = 'externalId',
  Id = 'id'
}

export type Valuation = {
  __typename?: 'Valuation';
  comment?: Maybe<Scalars['String']>;
  equationValue?: Maybe<Scalars['Float']>;
  equationValueSecondary?: Maybe<Scalars['Float']>;
  equationValueSecondaryTo?: Maybe<Scalars['Float']>;
  equationValueSecondaryYear?: Maybe<Scalars['Int']>;
  equationValueTo?: Maybe<Scalars['Float']>;
  equationValueYear?: Maybe<Scalars['Int']>;
  estimatedValue?: Maybe<Scalars['Float']>;
  estimatedValueTo?: Maybe<Scalars['Float']>;
  loanAppraisalValue?: Maybe<Scalars['Float']>;
  loanAppraisalValueTo?: Maybe<Scalars['Float']>;
  technicalValue?: Maybe<Scalars['Float']>;
  technicalValueTo?: Maybe<Scalars['Float']>;
};

export type Video = {
  __typename?: 'Video';
  url?: Maybe<Scalars['String']>;
};

export type LoginSendNewCodeInput = {
  key: Scalars['String'];
};

export type PortalInitializeResponse = {
  __typename?: 'portalInitializeResponse';
  redirectUrl: Scalars['String'];
};

export type PortalMenuCog = {
  __typename?: 'portalMenuCog';
  isExternal?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type PortalMenuItem = {
  __typename?: 'portalMenuItem';
  active?: Maybe<Scalars['Boolean']>;
  isExternal?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PortalMenuResponse = {
  __typename?: 'portalMenuResponse';
  data?: Maybe<PortalMenuRoot>;
  success: Scalars['Boolean'];
};

export type PortalMenuRoot = {
  __typename?: 'portalMenuRoot';
  cog?: Maybe<PortalMenuCog>;
  image?: Maybe<Scalars['String']>;
  items?: Maybe<Array<PortalMenuItem>>;
};

export type EstateCarouselQueryVariables = Exact<{
  input: SearchInput;
  filter?: Maybe<SearchFilterEstate>;
}>;

export type EstateCarouselQuery = { __typename?: 'Query' } & {
  search: { __typename?: 'Search' } & {
    estate?: Maybe<
      { __typename?: 'SearchResultEstate' } & {
        list: Array<
          Maybe<
            { __typename?: 'Estate' } & Pick<Estate, 'assignmentNumber' | 'type' | 'postalPlace'> & {
                images?: Maybe<{ __typename?: 'Images' } & { main?: Maybe<{ __typename?: 'Image' } & Pick<Image, 'url'>> }>;
              }
          >
        >;
      }
    >;
  };
};

export type SearchEstateQueryVariables = Exact<{
  input: SearchInput;
  filter?: Maybe<SearchFilterEstate>;
}>;

export type SearchEstateQuery = { __typename?: 'Query' } & {
  search: { __typename?: 'Search' } & {
    estate?: Maybe<
      { __typename?: 'SearchResultEstate' } & Pick<SearchResultEstate, 'total'> & {
          list: Array<
            Maybe<
              { __typename?: 'Estate' } & Pick<Estate, 'estateId' | 'assignmentNumber' | 'streetAddress' | 'type' | 'postalPlace' | 'sold'> & {
                  size?: Maybe<
                    { __typename?: 'Size' } & Pick<
                      Size,
                      'grossInternalArea' | 'grossInternalAreaTo' | 'primaryArea' | 'primaryAreaTo' | 'usableArea' | 'usableAreaTo'
                    >
                  >;
                  prices?: Maybe<{ __typename?: 'Prices' } & Pick<Prices, 'askingPrice' | 'askingPriceTo'>>;
                  images?: Maybe<{ __typename?: 'Images' } & { main?: Maybe<{ __typename?: 'Image' } & Pick<Image, 'url'>> }>;
                }
            >
          >;
        }
    >;
  };
};

export type DepartmentEmployeesQueryVariables = Exact<{
  input: DepartmentInput;
}>;

export type DepartmentEmployeesQuery = { __typename?: 'Query' } & {
  department?: Maybe<
    { __typename?: 'Department' } & Pick<Department, 'name' | 'postalPlace'> & {
        employees?: Maybe<
          Array<
            Maybe<
              { __typename?: 'Employee' } & Pick<Employee, 'title' | 'name' | 'email' | 'mobilePhone'> & {
                  links?: Maybe<{ __typename?: 'EmployeeLinks' } & { profile?: Maybe<{ __typename?: 'EmployeeLink' } & Pick<EmployeeLink, 'path'>> }>;
                  image?: Maybe<{ __typename?: 'EmployeeImage' } & Pick<EmployeeImage, 'url'>>;
                }
            >
          >
        >;
      }
  >;
};

export type ProjectStatisticsQueryVariables = Exact<{
  input: SearchInput;
  filter?: Maybe<SearchFilterEstate>;
}>;

export type ProjectStatisticsQuery = { __typename?: 'Query' } & {
  search: { __typename?: 'Search' } & {
    estate?: Maybe<
      { __typename?: 'SearchResultEstate' } & {
        aggregations?: Maybe<
          { __typename?: 'SearchEstateAggregations' } & {
            projectStatistics?: Maybe<
              { __typename?: 'SearchProjectStatistics' } & Pick<SearchProjectStatistics, 'projectCount' | 'unitsSold' | 'unitsAvailable'>
            >;
          }
        >;
      }
    >;
  };
};

export const EstateCarouselDocument = gql`
  query EstateCarousel($input: SearchInput!, $filter: SearchFilterEstate) {
    search(input: $input) {
      estate(filter: $filter) {
        list {
          assignmentNumber
          type
          postalPlace
          images {
            main {
              url
            }
          }
        }
      }
    }
  }
`;

/**
 * __useEstateCarouselQuery__
 *
 * To run a query within a React component, call `useEstateCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateCarouselQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEstateCarouselQuery(baseOptions: Apollo.QueryHookOptions<EstateCarouselQuery, EstateCarouselQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EstateCarouselQuery, EstateCarouselQueryVariables>(EstateCarouselDocument, options);
}
export function useEstateCarouselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateCarouselQuery, EstateCarouselQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EstateCarouselQuery, EstateCarouselQueryVariables>(EstateCarouselDocument, options);
}
export type EstateCarouselQueryHookResult = ReturnType<typeof useEstateCarouselQuery>;
export type EstateCarouselLazyQueryHookResult = ReturnType<typeof useEstateCarouselLazyQuery>;
export type EstateCarouselQueryResult = Apollo.QueryResult<EstateCarouselQuery, EstateCarouselQueryVariables>;
export const SearchEstateDocument = gql`
  query SearchEstate($input: SearchInput!, $filter: SearchFilterEstate) {
    search(input: $input) {
      estate(filter: $filter) {
        total
        list {
          estateId
          assignmentNumber
          streetAddress
          type
          postalPlace
          sold
          size {
            grossInternalArea
            grossInternalAreaTo
            primaryArea
            primaryAreaTo
            usableArea
            usableAreaTo
          }
          prices {
            askingPrice
            askingPriceTo
          }
          images {
            main {
              url
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSearchEstateQuery__
 *
 * To run a query within a React component, call `useSearchEstateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEstateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEstateQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchEstateQuery(baseOptions: Apollo.QueryHookOptions<SearchEstateQuery, SearchEstateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchEstateQuery, SearchEstateQueryVariables>(SearchEstateDocument, options);
}
export function useSearchEstateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEstateQuery, SearchEstateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchEstateQuery, SearchEstateQueryVariables>(SearchEstateDocument, options);
}
export type SearchEstateQueryHookResult = ReturnType<typeof useSearchEstateQuery>;
export type SearchEstateLazyQueryHookResult = ReturnType<typeof useSearchEstateLazyQuery>;
export type SearchEstateQueryResult = Apollo.QueryResult<SearchEstateQuery, SearchEstateQueryVariables>;
export const DepartmentEmployeesDocument = gql`
  query DepartmentEmployees($input: DepartmentInput!) {
    department(input: $input) {
      name
      postalPlace
      employees {
        title
        name
        email
        mobilePhone
        links {
          profile {
            path
          }
        }
        image {
          url
        }
      }
    }
  }
`;

/**
 * __useDepartmentEmployeesQuery__
 *
 * To run a query within a React component, call `useDepartmentEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentEmployeesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDepartmentEmployeesQuery(baseOptions: Apollo.QueryHookOptions<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>(DepartmentEmployeesDocument, options);
}
export function useDepartmentEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>(DepartmentEmployeesDocument, options);
}
export type DepartmentEmployeesQueryHookResult = ReturnType<typeof useDepartmentEmployeesQuery>;
export type DepartmentEmployeesLazyQueryHookResult = ReturnType<typeof useDepartmentEmployeesLazyQuery>;
export type DepartmentEmployeesQueryResult = Apollo.QueryResult<DepartmentEmployeesQuery, DepartmentEmployeesQueryVariables>;
export const ProjectStatisticsDocument = gql`
  query ProjectStatistics($input: SearchInput!, $filter: SearchFilterEstate) {
    search(input: $input) {
      estate(filter: $filter) {
        aggregations {
          projectStatistics {
            projectCount
            unitsSold
            unitsAvailable
          }
        }
      }
    }
  }
`;

/**
 * __useProjectStatisticsQuery__
 *
 * To run a query within a React component, call `useProjectStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectStatisticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProjectStatisticsQuery(baseOptions: Apollo.QueryHookOptions<ProjectStatisticsQuery, ProjectStatisticsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectStatisticsQuery, ProjectStatisticsQueryVariables>(ProjectStatisticsDocument, options);
}
export function useProjectStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectStatisticsQuery, ProjectStatisticsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectStatisticsQuery, ProjectStatisticsQueryVariables>(ProjectStatisticsDocument, options);
}
export type ProjectStatisticsQueryHookResult = ReturnType<typeof useProjectStatisticsQuery>;
export type ProjectStatisticsLazyQueryHookResult = ReturnType<typeof useProjectStatisticsLazyQuery>;
export type ProjectStatisticsQueryResult = Apollo.QueryResult<ProjectStatisticsQuery, ProjectStatisticsQueryVariables>;
